/* PLANTILLAS DE LA TAZA (Xavi, 03/10): diseños ya hechos para empezar, con huecos de foto (una cámara dibujada: se toca,
 * se elige la foto y queda recortada a ese hueco) y textos que se cambian tocándolos.
 *
 * Cada plantilla es una función que devuelve el estado del editor libre (mismo formato que foto() de editor-libre.js):
 * elementos en cm sobre la superficie de 20 × 9,5, de atrás a delante. Las caras visibles son el lado izquierdo (x 0–8)
 * y el derecho (x 12–20); el centro (8–12) es el asa. editor-libre.js lo monta con ctrl.plantilla(estado).
 *
 * Los huecos vacíos no entran en el precio ni en el pedido (son como el texto de ejemplo). */
(function () {
  'use strict';

  /* El mismo módulo sirve a la CAMISETA (Xavi, 25/10/2026: «sigue con las camisetas de Navidad»): la ficha dice su tema en window.IMP_CAMISETA_TEMA
     (metacampo custom.camiseta_tema) y la superficie es el recuadro del pecho, 30 × 40 cm, en vez de los 20 × 9,5 de la taza. */
  var CAM = !!window.IMP_CAMISETA_TEMA, PROD = CAM ? (/sudadera/i.test(location.pathname) ? 'sudadera' : 'camiseta') : 'taza';   // la sudadera comparte las plantillas de la camiseta
  var W = CAM ? 30 : 20, H = CAM ? 40 : 9.5;
  var F = {
    anton: "'Anton', sans-serif", lobster: "'Lobster', cursive", boda: "'Great Vibes', cursive", gruesa: "'Alfa Slab One', serif",
    cinzel: "'Cinzel', serif", gorda: "'Titan One', cursive", poppins: "'Poppins', sans-serif", pacifico: "'Pacifico', cursive",
    playfair: "'Playfair Display', serif", fredoka: "'Fredoka', sans-serif", firma: "'Yellowtail', cursive", creepster: "'Creepster', cursive"
  };
  var FAMILIAS = ['Anton', 'Lobster', 'Great Vibes', 'Alfa Slab One', 'Cinzel', 'Titan One', 'Poppins', 'Pacifico', 'Playfair Display', 'Fredoka', 'Yellowtail', 'Creepster'];

  /* ---------- piezas ---------- */
  function lienzoColor(hex, wcm, hcm) {
    /* Resolución suficiente para el tamaño real (unos 130 px/cm): con 80 px de ancho una casilla de color de 3 cm salía «Borrosa» en el aviso
       de resolución del editor. Los fondos (20 × 9,5 cm) siguen en 80 px: el color liso no tiene detalle. */
    var ancho = wcm >= W ? 80 : Math.max(80, Math.min(1400, Math.round(wcm * 130)));
    var c = document.createElement('canvas'); c.width = ancho; c.height = Math.max(8, Math.round(ancho * hcm / wcm));
    var g = c.getContext('2d'); g.fillStyle = hex; g.fillRect(0, 0, c.width, c.height);
    return c.toDataURL('image/png');
  }
  function base(o) {
    o.visible = true; o.rot = o.rot || 0; o.volteado = false; o.wRef = o.w; o.hRef = o.h; o.original = null; return o;
  }
  /* OJO (29/10/2026, pedido 2043): en sublimación el gris muy claro SÍ imprime. Los fondos «blancos con degradado» (#ffffff → #f1f1f4) salían como papel gris;
     los fondos que son blanco de verdad se piden con fondo('#ffffff'). */
  function fondo(hex) {
    return base({ tipo: 'imagen', fondo: true, colorFondo: hex, cx: W / 2, cy: H / 2, w: W, h: H, src: lienzoColor(hex, W, H), _c: hex });
  }
  /* Fondo con degradado y textura (el motor de las banderas, fondos-lienzo.js). cols = 2-3 colores, tipo v/d/r, tx = textura.
     Para el pedido se dibuja a 100 px/cm y se guarda como blob (una URL corta, no un data: de un mega que se copiaría en cada
     paso del historial); para las miniaturas, a 12 px/cm. */
  var calidad = 'alta';
  function aBlobUrl(cv) {
    var d = cv.toDataURL('image/jpeg', 0.92), bin = atob(d.split(',')[1]), u8 = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
    return URL.createObjectURL(new Blob([u8], { type: 'image/jpeg' }));
  }
  function fondoG(cols, tipo, tx, f) {
    var mini = calidad === 'mini', cv = document.createElement('canvas');
    cv.width = Math.round(W * (mini ? 12 : 100)); cv.height = Math.round(H * (mini ? 12 : 100));
    if (window.FondosLienzo) window.FondosLienzo.pintar(cv, W, H, { c: cols, t: tipo, tx: tx, f: f || 1, e: 0.5 });
    else { var g = cv.getContext('2d'); g.fillStyle = cols[0]; g.fillRect(0, 0, cv.width, cv.height); }
    var src = mini ? cv.toDataURL('image/jpeg', 0.8) : aBlobUrl(cv);
    return base({ tipo: 'imagen', fondo: true, colorFondo: null, cx: W / 2, cy: H / 2, w: W, h: H, src: src, _c: cols[0], _img: src });
  }

  /* Fondo ilustrado hecho con la API de imágenes (assets/taza-fondo-<id>.jpg, 2048 × 968 px = ~260 ppp a 20 cm). Se pide como 'bg:<id>' y, al elegir el
     montaje, resolverFondos() lo descarga y lo cambia por una URL blob (igual que fondoG), para que el lienzo no quede «manchado» al sacar el archivo. */
  function urlFondo(id) {
    var sc = document.querySelector('script[src*="taza-plantillas"]'), b = sc ? sc.src.replace(/taza-plantillas\.js.*$/, '') : '/cdn/shop/t/1/assets/';
    return b + 'taza-fondo-' + id + '.jpg';
  }
  function fondoImg(id) {
    return base({ tipo: 'imagen', fondo: true, colorFondo: null, cx: W / 2, cy: H / 2, w: W, h: H, src: 'bg:' + id, _c: '#ffffff' });
  }
  var cacheFondos = {};
  /* Dibujo hecho con la API de imágenes (assets/cam-<id>.webp, fotos reales recortadas con transparencia). Se pide como 'art:<id>' y resolverFondos() lo descarga y lo cambia por una URL blob. */
  function urlArte(id) {
    var sc = document.querySelector('script[src*="taza-plantillas"]'), b = sc ? sc.src.replace(/taza-plantillas\.js.*$/, '') : '/cdn/shop/t/1/assets/';
    return b + 'cam-' + id + '.webp';
  }
  function arte(id, cx, cy, w, h, rot) {
    var o = base({ tipo: 'imagen', fondo: false, colorFondo: null, cx: cx, cy: cy, w: w, h: h, src: 'art:' + id, _c: '#ffffff' });
    if (rot) o.rot = rot;
    return o;
  }
  function resolverFondos(est) {
    var ps = est.elementos.filter(function (e) { return typeof e.src === 'string' && /^(bg|art):/.test(e.src); }).map(function (e) {
      var art = e.src.indexOf('art:') === 0, id = e.src.slice(art ? 4 : 3), clave = (art ? 'art:' : '') + id, url = art ? urlArte : urlFondo;
      cacheFondos[clave] = cacheFondos[clave] || fetch(url(id)).then(function (r) { if (!r.ok) throw new Error('fondo'); return r.blob(); }).then(function (b) { return URL.createObjectURL(b); });
      return cacheFondos[clave].then(function (u) { e.src = u; e._img = u; }, function () { e.src = art ? lienzoColor('#ffffff', 1, 1) : lienzoColor('#ffffff', W, H); });   // sin red: fondo blanco, el montaje sigue valiendo
    });
    return Promise.all(ps).then(function () { return est; });
  }

  function caja(cx, cy, w, h, hex, forma) {
    var src = lienzoColor(hex, w, h);
    if (forma === 'circulo') {
      var c = document.createElement('canvas'); c.width = Math.max(200, Math.min(1400, Math.round(w * 130))); c.height = Math.max(8, Math.round(c.width * h / w));
      var g = c.getContext('2d'); g.fillStyle = hex; g.beginPath(); g.ellipse(c.width / 2, c.height / 2, c.width / 2, c.height / 2, 0, 0, Math.PI * 2); g.fill();
      src = c.toDataURL('image/png');
    }
    return base({ tipo: 'imagen', fondo: false, colorFondo: null, cx: cx, cy: cy, w: w, h: h, src: src, _c: hex, _f: forma || '' });
  }
  function hueco(cx, cy, w, h) {
    return base({ tipo: 'imagen', fondo: false, colorFondo: null, cx: cx, cy: cy, w: w, h: h, hueco: true });
  }
  /* Una foto DENTRO de una letra (Xavi, 25/10/2026): el hueco lleva de «borde» la silueta de la letra (el editor la dibuja con la fuente, ver construirMascaraLetra
     en editor-libre.js): estilo «letra:P:Anton:410x790» = la P de Anton estirada a un recuadro de 4,10 × 7,90 cm. */
  function huecoLetra(cx, cy, w, h, ch, fam) {
    var o = hueco(cx, cy, w, h);
    o.difuminado = 100; o.difumEstilo = 'letra:' + ch + ':' + fam + ':' + Math.round(w * 100) + 'x' + Math.round(h * 100);
    return o;
  }
  function texto(t, cx, cy, w, h, fuente, color, opc) {
    opc = opc || {};
    var o = base({ tipo: 'texto', fondo: false, colorFondo: null, cx: cx, cy: cy, w: w, h: h, texto: t, fontFamily: fuente, color: color,
      fontWeight: opc.peso || 'normal', fontStyle: 'normal', textDecoration: 'none', rot: opc.rot || 0 });
    if (opc.borde) { o.bordeAncho = opc.borde[0]; o.bordeColor = opc.borde[1]; }
    if (opc.pide) o.pide = true;         // el asistente pregunta este texto (un nombre que no se llama «Nombre» en el ejemplo)
    if (opc.inicial) o.inicial = true;   // la letra grande: el asistente le pone la inicial del primer nombre
    return o;
  }

  /* Zona segura: el editor deja 0,5 cm a los lados y más arriba/abajo por la curva de la boca de la taza. Cada cara usa x 1,5–7,5
     (izquierda) y 12,5–18,5 (derecha), centradas en 4,5 y 15,5: el recuadro seguro del editor mide unos 6 cm y NO está en el centro de
     cada ventana de 8 cm (el cuerpo de la taza visible de lado queda desplazado hacia dentro), y en vertical de 1,0 a 8,95. Cuatro casillas por cara (2 × 2) de 2,9 × 3,85 cm con 0,2 cm entre ellas;
     `x0` es el borde izquierdo de la cara. */
  var CL = 4.5, CR = 15.5;     // centro de cada cara
  function celdas(x0) {
    var cw = 2.9, ch = 3.85, g = 0.2, y0 = 1.0;
    return [
      { cx: x0 + cw / 2, cy: y0 + ch / 2, w: cw, h: ch },
      { cx: x0 + cw * 1.5 + g, cy: y0 + ch / 2, w: cw, h: ch },
      { cx: x0 + cw / 2, cy: y0 + ch * 1.5 + g, w: cw, h: ch },
      { cx: x0 + cw * 1.5 + g, cy: y0 + ch * 1.5 + g, w: cw, h: ch }
    ];
  }

  /* Letras en casillas de color con fotos (como «MAMÁ» o un año), a todo lo ancho de la taza, el centro también (Xavi, 25/10/2026): una columna por letra, con la
     letra y una foto apiladas en zigzag; con menos de 4 letras se completa con columnas de dos fotos. De x 1,5 a 18,5 cm. */
  function letrasMontaje(palabra, colorDe, fuente, fondoEl) {
    var n = palabra.length, N = Math.max(n, 4), g = 0.2, ch = 3.85, y0 = 1.0, ancho = 17, x0 = 1.5, i;
    var w = (ancho - (N - 1) * g) / N, els = [fondoEl], arriba = y0 + ch / 2, abajo = y0 + ch * 1.5 + g;
    for (i = 0; i < N; i++) {
      var cx = x0 + i * (w + g) + w / 2;
      if (i < n) {
        var cyL = i % 2 === 0 ? arriba : abajo, cyF = i % 2 === 0 ? abajo : arriba;
        els.push(caja(cx, cyL, w, ch, colorDe(i)));
        els.push(texto(palabra.charAt(i), cx, cyL, w * 0.7, ch * 0.7, fuente, '#ffffff'));
        els.push(hueco(cx, cyF, w, ch));
      } else { els.push(hueco(cx, arriba, w, ch)); els.push(hueco(cx, abajo, w, ch)); }
    }
    return { vista: 'panoramica', elementos: els };
  }
  /* Cada letra es una foto: una columna por letra, a todo el alto (7,9 cm), con la foto recortada a la forma de la letra. */
  function letrasDentro(palabra, fondoSpec) {
    return function () {
      var n = palabra.length, g = 0.2, ancho = 17, x0 = 1.5, w = (ancho - (n - 1) * g) / n, h = 3.85 * 2 + g, cy = 1.0 + h / 2, els = [fondoG(fondoSpec[0], fondoSpec[1], fondoSpec[2], fondoSpec[3])], i;
      for (i = 0; i < n; i++) els.push(huecoLetra(x0 + i * (w + g) + w / 2, cy, w, h, palabra.charAt(i), 'Anton'));
      return { vista: 'panoramica', elementos: els };
    };
  }
  function letrasYFotos(palabra, colores, fuente, fondoSpec) {
    return function () { return letrasMontaje(palabra, function (i) { return colores[i % colores.length]; }, fuente, fondoSpec ? fondoG(fondoSpec[0], fondoSpec[1], fondoSpec[2], fondoSpec[3]) : fondo('#ffffff')); };
  }

  /* ---------- las plantillas ---------- */
  var PLANTILLAS = [
    { id: 'mama', cat: 'familia', nombre: 'MAMÁ con fotos', nota: '4 letras y 4 fotos', f: letrasYFotos('MAMÁ', ['#e8344f', '#e8344f', '#e8344f', '#e8344f'], F.gorda, [['#ffffff', '#ffe3e8'], 'v', '', 1]) },
    { id: 'papa', cat: 'familia', nombre: 'PAPÁ con fotos', nota: '4 letras y 4 fotos', f: letrasYFotos('PAPÁ', ['#1f5fa8', '#1f5fa8', '#1f5fa8', '#1f5fa8'], F.gorda, [['#ffffff', '#dfeafb'], 'v', '', 1]) },
    { id: 'mama-letras', cat: 'familia', nombre: 'MAMÁ con las fotos dentro', nota: '4 fotos dentro de las letras', f: letrasDentro('MAMÁ', [['#fff4f6', '#ffd9e0'], 'v', '', 1]) },
    { id: 'papa-letras', cat: 'familia', nombre: 'PAPÁ con las fotos dentro', nota: '4 fotos dentro de las letras', f: letrasDentro('PAPÁ', [['#f2f7ff', '#cfe0f7'], 'v', '', 1]) },
    { id: 'amor-letras', cat: 'fiestas', nombre: 'AMOR con las fotos dentro', nota: '4 fotos dentro de las letras', f: letrasDentro('AMOR', [['#fff4f8', '#ffd3e3'], 'v', '', 1]) },
    { id: 'anio', cat: 'fiestas', nombre: 'Año con fotos', nota: 'Cumpleaños: 4 cifras y 4 fotos', f: letrasYFotos('1976', ['#6f8a5b', '#e8883a', '#7a5cc0', '#c9472e'], F.gorda, [['#ffffff', '#f1f1f6'], 'v', '', 1]) },
    { id: 'amor', cat: 'fiestas', nombre: 'AMOR con fotos', nota: '4 letras y 4 fotos', f: letrasYFotos('AMOR', ['#d62a6c', '#d62a6c', '#d62a6c', '#d62a6c'], F.gorda, [['#ffffff', '#ffe0ea'], 'v', '', 1]) },
    {
      id: 'nombres', cat: 'nombres', nombre: 'Nombres y corazón', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoG(['#ffffff', '#e9e9ef'], 'd', 'hexagonos', 0.6),
          texto('♥', CL, 3.0, 3.0, 3.0, F.poppins, '#2a2a2e', { peso: 'bold' }),
          texto('NOMBRES', CL, 6.1, 5.8, 1.8, F.anton, '#2a2a2e'),
          hueco(CR, 3.9, 5.8, 5.8),
          texto('FOREVER ♥', CR, 7.9, 5.8, 1.2, F.anton, '#2a2a2e')] };
      }
    },
    {
      id: 'vintage', cat: 'frases', nombre: 'Vintage Original', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoG(['#fffaf3', '#f2e3cf'], 'v', 'rombos', 0.7),
          texto('Premium Quality', CL, 2.4, 5.8, 1.2, F.lobster, '#d1262c'),
          texto('and', CL, 3.7, 2.2, 0.8, F.lobster, '#d1262c'),
          texto('AUTHENTIC', CL, 5.6, 5.8, 2.0, F.anton, '#d1262c'),
          hueco(CR, 3.9, 5.8, 5.6),
          texto('VINTAGE', CR, 7.35, 5.8, 1.6, F.anton, '#d1262c'),
          texto('Original', CR, 8.4, 4.6, 1.0, F.lobster, '#d1262c')] };
      }
    },
    {
      id: 'rey', cat: 'frases', nombre: 'Rey de la casa', nota: 'Una foto (mascota o persona)',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('rey'),
          texto('THE KING', CL, 2.6, 5.8, 1.7, F.cinzel, '#9b1c1c', { peso: 'bold' }),
          texto('of the', CL, 4.2, 3.2, 1.3, F.boda, '#9b1c1c'),
          texto('HOUSE', CL, 6.1, 5.8, 2.1, F.cinzel, '#9b1c1c', { peso: 'bold' }),
          hueco(CR, 4.0, 5.8, 6.0),
          texto('NOMBRE', CR, 8.0, 5.6, 1.1, F.cinzel, '#9b1c1c', { peso: 'bold' })] };
      }
    },
    {
      id: 'inicial', cat: 'nombres', nombre: 'Inicial y nombre', nota: 'Sin fotos, por los dos lados',
      f: function () {
        var els = [fondoImg('inicial')];
        [CL, CR].forEach(function (x) {
          els.push(texto('N', x, 4.7, 5.0, 6.4, F.gruesa, '#b5d99c', { inicial: true }));
          els.push(texto('Nombre', x, 5.6, 5.8, 3.2, F.boda, '#1f5a1f'));
        });
        return { vista: 'panoramica', elementos: els };
      }
    },
    {
      id: 'inicial-azul', cat: 'nombres', nombre: 'Inicial azul y nombre', nota: 'Sin fotos, por los dos lados',
      f: function () {
        var els = [fondoImg('inicial-azul')];
        [CL, CR].forEach(function (x) {
          els.push(texto('M', x, 5.0, 5.4, 7.6, F.playfair, '#aac6ee', { inicial: true }));
          els.push(texto('marc', x, 5.9, 5.8, 2.6, F.firma, '#17171a', { pide: true }));
        });
        return { vista: 'panoramica', elementos: els };
      }
    },
    {
      id: 'inicial-rosa', cat: 'nombres', nombre: 'Inicial rosa y nombre', nota: 'Sin fotos, por los dos lados',
      f: function () {
        var els = [fondoImg('inicial-rosa')];
        [CL, CR].forEach(function (x) {
          els.push(texto('P', x, 5.0, 5.4, 7.6, F.playfair, '#e3b4cf', { inicial: true }));
          els.push(texto('paula', x, 5.9, 5.8, 2.6, F.firma, '#17171a', { pide: true }));
        });
        return { vista: 'panoramica', elementos: els };
      }
    },
    {
      id: 'madres', cat: 'frases', nombre: 'La vida es mejor con…', nota: 'Sin fotos: cambia «madres» y el nombre',
      f: function () {
        var els = [fondoImg('madres')];
        [CL, CR].forEach(function (x) {
          els.push(texto('LA VIDA', x, 1.9, 5.8, 1.2, F.fredoka, '#d9a900', { peso: 'bold' }));
          els.push(texto('ES MEJOR CON', x, 3.2, 4.8, 0.9, F.fredoka, '#59a9a8', { peso: 'bold' }));
          els.push(texto('madres', x, 4.6, 5.8, 1.8, F.fredoka, '#2b2a78', { peso: 'bold' }));
          els.push(texto('COMO', x, 6.1, 2.2, 0.8, F.fredoka, '#d9a900', { peso: 'bold' }));
          els.push(texto('NOMBRE', x, 7.4, 5.8, 1.5, F.fredoka, '#59a9a8', { peso: 'bold' }));
        });
        return { vista: 'panoramica', elementos: els };
      }
    },
    /* ---- fiestas y temporadas ---- */
    {
      id: 'valentin-quiero', cat: 'fiestas', nombre: 'San Valentín: te quiero', nota: 'Sin fotos, por los dos lados',
      f: function () {
        var els = [fondoImg('corazones')];
        [CL, CR].forEach(function (x) {
          els.push(texto('♥', x, 2.7, 2.4, 2.4, F.poppins, '#d6204a', { peso: 'bold' }));
          els.push(texto('TE QUIERO', x, 4.9, 5.4, 1.8, F.anton, '#d6204a'));
          els.push(texto('Nombre', x, 6.8, 5.4, 2.0, F.boda, '#7a1030'));
        });
        return { vista: 'panoramica', elementos: els };
      }
    },
    {
      id: 'valentin-foto', cat: 'fiestas', nombre: 'San Valentín: nuestra foto', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('corazones'),
          hueco(CL, 3.7, 5.2, 5.2),
          texto('Nombre ♥ Nombre', CL, 7.2, 5.0, 1.1, F.pacifico, '#d6204a'),
          texto('TE', CR, 2.4, 3.0, 1.6, F.anton, '#d6204a'),
          texto('QUIERO', CR, 4.4, 5.8, 2.3, F.anton, '#d6204a'),
          texto('♥', CR, 6.9, 2.4, 2.4, F.poppins, '#d6204a', { peso: 'bold' })] };
      }
    },
    {
      id: 'halloween-boo', cat: 'fiestas', nombre: 'Halloween: BOO!', nota: 'Sin fotos, por los dos lados',
      f: function () {
        var els = [fondoG(['#2f2b4a', '#0d0c14'], 'r', 'estrellas', 0.9)];
        [CL, CR].forEach(function (x) {
          els.push(caja(x, 3.1, 4.0, 4.0, '#ffd36b', 'circulo'));
          els.push(texto('BOO!', x, 3.1, 3.0, 1.6, F.creepster, '#1b1a24'));
          els.push(texto('TRUCO', x, 6.0, 5.8, 1.8, F.creepster, '#ff7a1a'));
          els.push(texto('O TRATO', x, 7.8, 5.2, 1.4, F.creepster, '#ffffff'));
        });
        return { vista: 'panoramica', elementos: els };
      }
    },
    {
      id: 'halloween-foto', cat: 'fiestas', nombre: 'Halloween: foto y nombre', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoG(['#2f2b4a', '#0d0c14'], 'r', 'estrellas', 0.9),
          hueco(CL, 3.7, 5.8, 5.4),
          texto('FELIZ HALLOWEEN', CL, 7.5, 5.8, 1.2, F.creepster, '#ff7a1a'),
          texto('Nombre', CL, 8.5, 4.6, 0.8, F.creepster, '#ffffff'),
          texto('BOO!', CR, 3.7, 5.8, 3.6, F.creepster, '#ff7a1a'),
          texto('Nombre', CR, 5.8, 5.8, 1.8, F.firma, '#ffffff')] };
      }
    },
    {
      id: 'navidad-feliz', cat: 'fiestas', nombre: 'Navidad: Feliz Navidad', nota: 'Sin fotos, por los dos lados',
      f: function () {
        var els = [fondoImg('navidad-feliz')];
        [CL, CR].forEach(function (x) {
          els.push(texto('FELIZ', x, 2.5, 4.4, 1.5, F.lobster, '#ffffff'));
          els.push(texto('NAVIDAD', x, 4.4, 5.6, 1.8, F.gruesa, '#ffffff'));
          els.push(texto('★', x, 5.8, 1.5, 1.5, F.poppins, '#ffd166'));
          els.push(texto('Nombre', x, 7.4, 5.8, 1.5, F.boda, '#ffd166'));
        });
        return { vista: 'panoramica', elementos: els };
      }
    },
    {
      id: 'navidad-foto', cat: 'fiestas', nombre: 'Navidad: familia con foto', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('navidad-foto'),
          hueco(CL, 4.1, 5.4, 4.6),
          texto('Feliz Navidad', CL, 7.5, 5.4, 1.3, F.lobster, '#ffffff'),
          texto('FAMILIA', CR, 2.6, 5.0, 1.1, F.cinzel, '#ffd166', { peso: 'bold' }),
          texto('Nombre', CR, 4.4, 5.6, 2.6, F.boda, '#ffffff'),
          texto('★ ★ ★', CR, 6.1, 3.4, 0.9, F.poppins, '#ffd166'),
          texto('Feliz Navidad', CR, 7.5, 5.2, 1.1, F.lobster, '#ffffff')] };
      }
    },
    {
      id: 'ai-regalo', cat: 'fiestas', nombre: 'Amigo invisible: etiqueta de regalo', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('ai-regalo'),
          texto('Amigo invisible', CL, 2.0, 5.0, 1.0, F.lobster, '#b3121f'),
          hueco(CL, 4.7, 4.8, 3.6),
          texto('2026', CL, 7.4, 3.0, 1.1, F.cinzel, '#14532d', { peso: 'bold' }),
          texto('PARA', CR, 2.3, 3.0, 0.9, F.cinzel, '#14532d', { peso: 'bold' }),
          texto('Nombre', CR, 4.3, 5.6, 2.6, F.boda, '#b3121f'),
          texto('★ ★ ★', CR, 6.0, 3.4, 0.9, F.poppins, '#c9971c'),
          texto('amigo invisible', CR, 7.3, 4.6, 0.85, F.lobster, '#14532d')] };
      }
    },
    {
      id: 'ai-misterio', cat: 'fiestas', nombre: 'Amigo invisible: ¿quién será?', nota: 'Sin fotos',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('ai-misterio'),
          texto('AMIGO', CL, 2.6, 4.6, 1.5, F.anton, '#ffd166'),
          texto('INVISIBLE', CL, 4.1, 5.0, 1.5, F.anton, '#ffd166'),
          texto('¿Quién será?', CL, 5.9, 5.0, 1.3, F.lobster, '#ffffff'),
          texto('Navidad', CL, 7.4, 3.4, 0.9, F.cinzel, '#ffffff', { peso: 'bold' }),
          texto('PARA', CR, 2.6, 3.0, 0.9, F.cinzel, '#ffffff', { peso: 'bold' }),
          texto('Nombre', CR, 4.5, 5.6, 2.8, F.boda, '#ffd166'),
          texto('★ ★ ★', CR, 6.3, 3.4, 0.9, F.poppins, '#ffd166'),
          texto('Feliz Navidad', CR, 7.5, 5.2, 1.1, F.lobster, '#ffffff')] };
      }
    },
    {
      id: 'ai-divertida', cat: 'fiestas', nombre: 'Amigo invisible: con su foto', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('ai-divertida'),
          hueco(CL, 4.0, 5.0, 4.6),
          texto('Amigo invisible', CL, 7.1, 4.4, 0.85, F.lobster, '#b3121f'),
          texto('AMIGO', CR, 2.4, 4.4, 1.5, F.anton, '#b3121f'),
          texto('INVISIBLE', CR, 3.9, 5.0, 1.5, F.anton, '#b3121f'),
          texto('Nombre', CR, 5.7, 5.4, 2.0, F.pacifico, '#14532d'),
          texto('2026', CR, 7.5, 3.0, 1.0, F.poppins, '#17171a', { peso: 'bold' })] };
      }
    },
    {
      id: 'reyes-carta', cat: 'fiestas', nombre: 'Reyes: carta a los Reyes Magos', nota: 'Sin fotos',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('reyes-carta'),
          texto('Querido', CL, 2.2, 3.6, 1.1, F.lobster, '#7a1f1f'),
          texto('MELCHOR', CL, 3.6, 4.6, 1.2, F.cinzel, '#7a1f1f', { peso: 'bold' }),
          texto('GASPAR', CL, 4.8, 4.2, 1.2, F.cinzel, '#7a1f1f', { peso: 'bold' }),
          texto('y BALTASAR', CL, 6.0, 4.8, 1.2, F.cinzel, '#7a1f1f', { peso: 'bold' }),
          texto('¡Te lo he pedido!', CL, 7.4, 4.8, 1.0, F.lobster, '#14532d'),
          texto('De:', CR, 2.5, 2.4, 1.0, F.lobster, '#7a1f1f'),
          texto('Nombre', CR, 4.4, 5.6, 2.8, F.boda, '#7a1f1f'),
          texto('★ ★ ★', CR, 6.3, 3.4, 0.9, F.poppins, '#b8860b'),
          texto('Reyes Magos', CR, 7.5, 4.2, 0.95, F.cinzel, '#7a1f1f', { peso: 'bold' })] };
      }
    },
    {
      id: 'reyes-foto', cat: 'fiestas', nombre: 'Reyes: de los Reyes Magos', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('reyes-foto'),
          hueco(CL, 4.0, 4.8, 4.4),
          texto('Reyes Magos', CL, 6.9, 4.6, 1.1, F.lobster, '#7a1f1f'),
          texto('PARA', CR, 2.5, 3.0, 0.9, F.cinzel, '#4a2a6a', { peso: 'bold' }),
          texto('Nombre', CR, 4.4, 5.6, 2.8, F.boda, '#7a1f1f'),
          texto('★ ★ ★', CR, 6.2, 3.4, 0.9, F.poppins, '#b8860b'),
          texto('Reyes Magos', CR, 7.4, 4.6, 1.1, F.lobster, '#4a2a6a')] };
      }
    },
    {
      id: 'reyes-corona', cat: 'fiestas', nombre: 'Reyes: el rey (o la reina) de la casa', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('reyes-corona'),
          hueco(CL, 4.7, 4.8, 5.4),
          texto('EL REY', CR, 3.0, 4.4, 1.6, F.anton, '#7a1f1f'),
          texto('DE LA CASA', CR, 4.4, 5.0, 1.2, F.anton, '#7a1f1f'),
          texto('Nombre', CR, 6.0, 5.4, 2.0, F.boda, '#7a1f1f'),
          texto('★ ★ ★', CR, 7.5, 3.4, 0.9, F.poppins, '#b8860b')] };
      }
    },
    {
      id: 'legend', cat: 'familia', nombre: 'The Man, The Myth, The Legend', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('legend'),
          texto('THE MAN.', CL, 2.5, 5.8, 2.0, F.anton, '#17171a'),
          texto('THE MYTH.', CL, 4.7, 5.8, 2.0, F.anton, '#17171a'),
          texto('THE LEGEND.', CL, 6.9, 5.8, 2.0, F.anton, '#17171a'),
          hueco(CR, 4.7, 4.6, 4.6)] };
      }
    },
    {
      id: 'mejor-papa-foto', cat: 'familia', nombre: 'El mejor Papá, con su foto', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('mejor-papa-foto'),
          texto('el mejor', CL, 3.5, 3.6, 1.3, F.lobster, '#7a3b1d'),
          texto('Papá', CL, 5.4, 4.6, 2.4, F.lobster, '#17171a'),
          texto('♥', CL, 7.0, 1.4, 1.4, F.poppins, '#e8605a'),
          hueco(CR, 4.7, 4.2, 4.2)] };
      }
    },
    {
      id: 'love', cat: 'fiestas', nombre: 'LOVE con corazones y foto', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('love'),
          texto('LO', CL, 3.1, 5.8, 3.6, F.anton, '#e8344f'),
          texto('VE', CL, 6.4, 5.8, 3.6, F.anton, '#f4a6b8'),
          hueco(CR, 4.3, 5.4, 5.2),
          texto('Nombre & Nombre', CR, 7.9, 5.6, 1.1, F.firma, '#e8344f')] };
      }
    },
    {
      id: 'youyme', cat: 'fiestas', nombre: 'You & Me', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('youyme'),
          texto('you', CL, 2.6, 5.0, 3.2, F.boda, '#1b2e5c'),
          texto('& Me', CL, 5.4, 5.6, 3.4, F.boda, '#1b2e5c'),
          texto('♥ ♥', CL, 8.0, 3.4, 1.5, F.poppins, '#e8605a'),
          hueco(CR, 4.1, 5.4, 5.0),
          texto('Nombre & Nombre', CR, 7.8, 5.8, 1.1, F.firma, '#1b2e5c')] };
      }
    },
    {
      id: 'friends', cat: 'fiestas', nombre: 'Forever Friends', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('friends'),
          texto('♥', CL, 3.1, 3.4, 3.4, F.poppins, '#2a2a30'),
          texto('NOMBRES', CL + 0.2, 6.4, 5.0, 2.0, F.anton, '#2a2a30'),
          texto('FOREVER ♥', CR, 1.7, 5.4, 1.4, F.anton, '#2a2a30'),
          hueco(CR, 4.9, 5.2, 4.6),
          texto('FRIENDS', CR, 8.0, 5.0, 1.5, F.anton, '#2a2a30')] };
      }
    },
    {
      id: 'cumple', cat: 'fiestas', nombre: 'Feliz cumpleaños', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('cumple'),
          texto('FELIZ', CL, 2.6, 4.2, 1.5, F.lobster, '#e8883a'),
          texto('CUMPLEAÑOS', CL, 4.4, 5.8, 2.0, F.anton, '#7a5cc0'),
          texto('Nombre', CL, 5.8, 5.8, 2.4, F.pacifico, '#d62a6c'),
          hueco(CR, 3.9, 5.2, 5.6),
          texto('★ 40 ★', CR, 7.6, 4.6, 1.1, F.gorda, '#e8883a')] };
      }
    },
    /* ---- familia y nombres ---- */
    {
      id: 'mejor-mama', cat: 'familia', nombre: 'La mejor mamá del mundo', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('mejor-mama'),
          texto('LA MEJOR', CL, 2.6, 5.4, 1.4, F.anton, '#e0457b'),
          texto('MAMÁ', CL, 4.8, 5.4, 3.0, F.gruesa, '#e0457b'),
          texto('DEL MUNDO', CL, 6.9, 5.4, 1.4, F.anton, '#e0457b'),
          texto('♥', CL, 8.0, 0.9, 0.9, F.poppins, '#e0457b', { peso: 'bold' }),
          hueco(CR, 4.0, 5.2, 5.6),
          texto('Nombre', CR, 7.5, 4.6, 1.2, F.pacifico, '#e0457b')] };
      }
    },
    {
      id: 'mejor-papa', cat: 'familia', nombre: 'El mejor papá del mundo', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('mejor-papa'),
          texto('EL MEJOR', CL, 2.6, 5.4, 1.4, F.anton, '#1f5fa8'),
          texto('PAPÁ', CL, 4.8, 5.4, 3.0, F.gruesa, '#1f5fa8'),
          texto('DEL MUNDO', CL, 6.9, 5.4, 1.4, F.anton, '#1f5fa8'),
          texto('★', CL, 8.0, 0.9, 0.9, F.poppins, '#1f5fa8', { peso: 'bold' }),
          hueco(CR, 4.0, 5.2, 5.6),
          texto('Nombre', CR, 7.5, 4.6, 1.2, F.pacifico, '#1f5fa8')] };
      }
    },
    {
      id: 'abuela', cat: 'familia', nombre: 'Abuela (o abuelo) con foto', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('abuela'),
          texto('Te quiero', CL, 2.8, 5.4, 1.9, F.firma, '#8a4fbf'),
          texto('ABUELA', CL, 5.0, 5.8, 2.6, F.gruesa, '#8a4fbf'),
          texto('de Nombre', CL, 6.9, 5.0, 1.4, F.boda, '#8a4fbf'),
          hueco(CR, 4.1, 5.2, 5.6),
          texto('♥', CR, 7.7, 1.1, 1.1, F.poppins, '#8a4fbf', { peso: 'bold' })] };
      }
    },
    {
      id: 'pareja', cat: 'nombres', nombre: 'Pareja y fecha', nota: 'Sin fotos, por los dos lados',
      f: function () {
        var els = [fondoImg('pareja')];
        [CL, CR].forEach(function (x) {
          els.push(texto('Nombre', x, 2.8, 5.4, 2.0, F.boda, '#b08d57'));
          els.push(texto('&', x, 4.7, 1.6, 1.8, F.playfair, '#b08d57'));
          els.push(texto('Nombre', x, 6.5, 5.4, 2.0, F.boda, '#b08d57'));
          els.push(texto('12 · 06 · 2026', x, 7.9, 5.0, 0.8, F.cinzel, '#7d6a4a', { peso: 'bold' }));
        });
        return { vista: 'panoramica', elementos: els };
      }
    },
    {
      id: 'collage', cat: 'fotos', nombre: 'Collage de fotos', nota: 'Cinco fotos y un nombre',
      f: function () {
        return { vista: 'panoramica', elementos: [fondo('#ffffff'),
          hueco(CL, 3.15, 5.8, 4.3), hueco(2.95, 6.65, 2.9, 2.5), hueco(6.05, 6.65, 2.9, 2.5),
          texto('CUSTOM NAME', CL, 8.5, 5.8, 0.8, F.anton, '#17171a'),
          hueco(13.95, 3.1, 2.9, 4.2), hueco(17.05, 3.1, 2.9, 4.2), hueco(CR, 6.85, 5.8, 3.0),
          texto('TEXT / MESSAGE', CR, 8.65, 5.8, 0.6, F.anton, '#17171a')] };
      }
    },
    {
      id: 'cuatro', cat: 'fotos', nombre: 'Cuatro fotos por lado', nota: 'Ocho fotos',
      f: function () {
        var els = [fondo('#ffffff')];
        celdas(1.5).concat(celdas(12.5)).forEach(function (c) { els.push(hueco(c.cx, c.cy, c.w, c.h)); });
        return { vista: 'panoramica', elementos: els };
      }
    },
    {
      id: 'frase', cat: 'frases', nombre: 'Frase grande', nota: 'Sin fotos: cambia el número y el texto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('frase'),
          texto('A MIS', CL, 1.6, 3.0, 0.9, F.anton, '#17171a'),
          texto('50', CL, 3.3, 5.2, 2.8, F.anton, '#17171a'),
          texto('AÑOS ESTOY', CL, 5.5, 5.8, 1.4, F.anton, '#17171a'),
          texto('DE MARAVILLA', CL, 7.15, 5.8, 1.4, F.anton, '#d1262c'),
          texto('A MIS', CR, 1.6, 3.0, 0.9, F.anton, '#17171a'),
          texto('50', CR, 3.3, 5.2, 2.8, F.anton, '#17171a'),
          texto('AÑOS ESTOY', CR, 5.5, 5.8, 1.4, F.anton, '#17171a'),
          texto('DE MARAVILLA', CR, 7.15, 5.8, 1.4, F.anton, '#d1262c')] };
      }
    },
    {
      id: 'panoramica', cat: 'fotos', nombre: 'Foto de lado a lado', nota: 'Una foto panorámica y un nombre',
      f: function () {
        return { vista: 'panoramica', elementos: [fondo('#ffffff'), hueco(10, 4.975, 18.6, 7.95),
          texto('NOMBRE', CL, 7.4, 5.8, 2.0, F.pacifico, '#ffffff', { borde: [0.1, '#17171a'] })] };
      }
    },
    {
      id: 'navidad-collage', cat: 'fiestas', nombre: 'Navidad: collage de 3 fotos', nota: '3 fotos y un nombre',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('navidad-collage'),
          texto('FELIZ NAVIDAD', CL, 1.7, 5.8, 1.3, F.lobster, '#ffffff'),
          hueco(CL, 5.2, 5.8, 5.2),
          texto('Nombre', CL, 8.5, 5.8, 1.1, F.boda, '#ffd166'),
          hueco(CR, 2.9, 5.8, 3.6), hueco(CR, 6.5, 5.8, 3.4),
          texto('★ 2026 ★', CR, 8.6, 5.0, 1.0, F.gruesa, '#ffd166')] };
      }
    },
    {
      id: 'navidad-primera', cat: 'fiestas', nombre: 'Nuestra primera Navidad', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('navidad-primera'),
          texto('Nuestra', CL, 2.2, 5.6, 1.6, F.boda, '#b3121f'),
          texto('PRIMERA', CL, 4.0, 5.6, 1.6, F.gruesa, '#1f8a4c'),
          texto('NAVIDAD', CL, 5.9, 5.6, 1.6, F.gruesa, '#b3121f'),
          texto('Nombre · 2026', CL, 7.9, 5.6, 1.1, F.pacifico, '#1f8a4c'),
          hueco(CR, 4.6, 5.8, 6.4),
          texto('★ ★ ★', CR, 8.6, 3.6, 0.9, F.poppins, '#b3121f')] };
      }
    },
    {
      id: 'abuelo', cat: 'familia', nombre: 'Abuelo con foto', nota: 'Una foto',
      f: function () {
        return { vista: 'panoramica', elementos: [fondoImg('abuelo'),
          texto('Te quiero', CL, 2.8, 5.4, 1.9, F.firma, '#1f5fa8'),
          texto('ABUELO', CL, 5.0, 5.8, 2.6, F.gruesa, '#1f5fa8'),
          texto('de Nombre', CL, 6.9, 5.0, 1.4, F.boda, '#1f5fa8'),
          hueco(CR, 4.1, 5.2, 5.6),
          texto('♥', CR, 7.7, 1.1, 1.1, F.poppins, '#1f5fa8', { peso: 'bold' })] };
      }
    }
  ];

  /* ---------- COMPOSICIONES TÍPICAS (Xavi, 25/10/2026): lo primero que se enseña, en grande y con imagen de ejemplo (assets/taza-comp-<id>.jpg,
     generadas con la API de imágenes). Cada cara visible mide 6 × 7,95 cm (x 1,5–7,5 y 12,5–18,5); las fotos se apilan o se reparten en rejilla. ---------- */
  var CARA_Y = 1.0, CARA_H = 7.95, CARA_W = 6, GAP = 0.2;
  function fondoC() { return fondo('#ffffff'); }
  function pila(cx, n) {
    var h = (CARA_H - GAP * (n - 1)) / n, o = [], i;
    for (i = 0; i < n; i++) o.push(hueco(cx, CARA_Y + h / 2 + i * (h + GAP), CARA_W, h));
    return o;
  }
  function cara10(x0) {      // una foto ancha arriba y rejilla de 2 × 2 debajo
    var h = (CARA_H - GAP * 2) / 3, cw = (CARA_W - GAP) / 2, cx = x0 + CARA_W / 2, o = [hueco(cx, CARA_Y + h / 2, CARA_W, h)], r, k;
    for (r = 1; r <= 2; r++) for (k = 0; k < 2; k++) o.push(hueco(x0 + cw / 2 + k * (cw + GAP), CARA_Y + h / 2 + r * (h + GAP), cw, h));
    return o;
  }
  function compo(cl, cr) { return function () { return { vista: 'panoramica', elementos: [fondoC()].concat(cl(), cr()) }; }; }
  var COMPOSICIONES = [
    { id: 'todo', nombre: 'Todo foto', nota: '1 foto de lado a lado', f: function () { return { vista: 'panoramica', elementos: [fondoC(), hueco(10, 4.975, 18.6, CARA_H)] }; } },
    { id: 'nombre', nombre: 'Foto y nombre', nota: '1 foto y tu nombre', f: function () {
      return { vista: 'panoramica', elementos: [fondoC(), hueco(10, 4.975, 18.6, CARA_H), texto('NOMBRE', CL, 7.4, 5.8, 2.0, F.pacifico, '#ffffff', { borde: [0.1, '#17171a'] })] }; } },
    { id: 'lados', nombre: 'Una foto en cada lado', nota: '2 fotos', f: compo(function () { return [hueco(CL, 4.975, CARA_W, CARA_H)]; }, function () { return [hueco(CR, 4.975, CARA_W, CARA_H)]; }) },
    { id: 'lados-nombre', nombre: 'Foto y nombre en cada lado', nota: '2 fotos y 2 nombres', f: compo(
      function () { return [hueco(CL, 3.8, 5.6, 5.5), texto('NOMBRE', CL, 7.75, 5.8, 1.3, F.anton, '#17171a')]; },
      function () { return [hueco(CR, 3.8, 5.6, 5.5), texto('NOMBRE', CR, 7.75, 5.8, 1.3, F.anton, '#17171a')]; }) },
    { id: 'fnl', nombre: 'Foto a un lado, nombre al otro', nota: '1 foto y tu nombre', f: compo(
      function () { return [hueco(CL, 4.975, CARA_W, CARA_H)]; },
      function () { return [texto('NOMBRE', CR, 4.975, 5.8, 2.6, F.anton, '#17171a')]; }) },
    { id: 'c3', nombre: 'Collage de 3 fotos', nota: '1 grande y 2 pequeñas', f: compo(function () { return pila(CL, 1); }, function () { return pila(CR, 2); }) },
    { id: 'c4', nombre: 'Collage de 4 fotos', nota: '2 por cada lado', f: compo(function () { return pila(CL, 2); }, function () { return pila(CR, 2); }) },
    { id: 'c5', nombre: 'Collage de 5 fotos', nota: '2 y 3 fotos', f: compo(function () { return pila(CL, 2); }, function () { return pila(CR, 3); }) },
    { id: 'c6', nombre: 'Collage de 6 fotos', nota: '3 por cada lado', f: compo(function () { return pila(CL, 3); }, function () { return pila(CR, 3); }) },
    { id: 'c8', nombre: 'Collage de 8 fotos', nota: '4 por cada lado', f: compo(function () { return celdas(1.5).map(function (c) { return hueco(c.cx, c.cy, c.w, c.h); }); }, function () { return celdas(12.5).map(function (c) { return hueco(c.cx, c.cy, c.w, c.h); }); }) },
    { id: 'c10', nombre: 'Collage de 10 fotos', nota: '5 por cada lado', f: compo(function () { return cara10(1.5); }, function () { return cara10(12.5); }) }
  ];
  function urlComp(id) {
    var sc = document.querySelector('script[src*="taza-plantillas"]'), b = sc ? sc.src.replace(/taza-plantillas\.js.*$/, '') : '/cdn/shop/t/1/assets/';
    return b + 'taza-comp-' + (PROD === 'sudadera' ? 'sud-' : '') + id + '.jpg';
  }

  /* ---------- miniaturas ----------
     Se dibujan en HTML con la misma proporción (20 × 9,5), cada cm = 11 px: cajas de color, huecos grises con su cámara y los
     textos con su fuente, para que se vea qué trae cada una sin montar el editor. */
  var PX = 11;
  function miniatura(est) {
    var d = document.createElement('div'); d.className = 'tzp__mini'; d.style.width = (W * PX) + 'px'; d.style.height = (H * PX) + 'px';
    est.elementos.forEach(function (e) {
      var n = document.createElement('div'); n.className = 'tzp__m';
      n.style.left = ((e.cx - e.w / 2) * PX) + 'px'; n.style.top = ((e.cy - e.h / 2) * PX) + 'px';
      n.style.width = (e.w * PX) + 'px'; n.style.height = (e.h * PX) + 'px';
      if (e.tipo === 'texto') {
        n.className += ' tzp__m--t'; n.textContent = e.texto; n.style.fontFamily = e.fontFamily; n.style.color = e.color;
        n.style.fontWeight = e.fontWeight; n.style.fontSize = Math.max(6, e.h * PX * 0.78) + 'px';
        if (e.bordeAncho) n.style.webkitTextStroke = (e.h * PX * e.bordeAncho * 0.5) + 'px ' + e.bordeColor;
      } else if (e.hueco) { n.className += ' tzp__m--h'; n.innerHTML = '<span aria-hidden="true">📷</span>'; }
      else if (e._img) { n.style.background = 'url(' + e._img + ') center / 100% 100%'; }
      else { n.style.background = e._c; if (e._f === 'circulo') n.style.borderRadius = '50%'; }
      d.appendChild(n);
    });
    return d;
  }

  function cargarFuentes() {
    if (document.getElementById('edl-fuentes') || document.getElementById('tzp-fuentes')) return;
    var l = document.createElement('link'); l.id = 'tzp-fuentes'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?' + FAMILIAS.map(function (f) { return 'family=' + f.replace(/ /g, '+'); }).join('&') + '&display=swap';
    document.head.appendChild(l);
  }

  /* ---------- la ventana ---------- */
  var abierta = null;
  function cerrar() { if (abierta) { abierta.remove(); abierta = null; document.removeEventListener('keydown', alTeclear); } document.documentElement.classList.remove('tz-pleno'); liberarPagina(); }
  function alTeclear(ev) { if (ev.key === 'Escape') cerrar(); }

  function aviso(txt) {
    var a = document.createElement('div'); a.className = 'tzp__aviso'; a.setAttribute('role', 'status'); a.textContent = txt;
    document.body.appendChild(a);
    setTimeout(function () { a.classList.add('is-fuera'); }, 6500);
    setTimeout(function () { a.remove(); }, 7200);
  }

  // el panel (Plantillas, Dibujos) va pegado como el de Fondo: lateral en PC, hoja baja en móvil; la taza queda a la vista y el panel sigue abierto para probar varias cosas
  /* En móvil la hoja (Plantillas, Dibujos) tapa la barra de abajo y la web queda bloqueada mientras se elige (Xavi, 21/10): primero se sube el editor
     arriba del todo (de golpe, no suave) y luego se congela la página; al cerrar se devuelve el scroll donde estaba. */
  var bloqY = null;
  function esMovil() { return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches); }
  function bloquearPagina(sel) {
    if (!esMovil() || bloqY !== null) return;
    document.documentElement.classList.add('tz-hoja');          // CSS: la barra de pestañas sube y queda justo encima de la hoja
    var tab = sel && document.querySelector('.rop-libre-rail ' + sel); if (tab) tab.classList.add('is-activo');
    var ed = document.querySelector('.rop-libre-wrap') || document.querySelector('.edl');
    bloqY = window.scrollY || 0;
    if (ed) { var top = ed.getBoundingClientRect().top; if (top > 8) { window.scrollTo(0, bloqY + top - 4); bloqY = window.scrollY || 0; } }
    var b = document.body;
    b.style.position = 'fixed'; b.style.top = (-bloqY) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
  }
  function liberarPagina() {
    if (bloqY === null) return;
    document.documentElement.classList.remove('tz-hoja');
    [].forEach.call(document.querySelectorAll('.rop-libre-rail__b.is-activo'), function (x) { x.classList.remove('is-activo'); });
    var b = document.body, y = bloqY; bloqY = null;
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
    window.scrollTo(0, y);
  }
  function subirEditor(sel) { bloquearPagina(sel); }
  /* Una taza por tema (Xavi, 25/10/2026: «las plantillas las quitaría porque son mucho lío todo en el mismo producto; haría tazas por tema»).
     Cada ficha dice su tema en window.IMP_TAZA_TEMA (metacampo custom.taza_tema del producto, ver ropa.liquid) y el panel enseña SOLO los montajes
     de ese tema, en grande, con la imagen de ejemplo assets/taza-comp-<id>.jpg. Sin metacampo = «fotos». */
  /* ---------- CAMISETAS de Navidad (Xavi, 25/10/2026): superficie del pecho, 30 × 40 cm, sin fondo (vale en cualquier color de camiseta). Los dibujos
     (gorro, corona, árbol, guirnalda) se hicieron con la API de imágenes: assets/cam-<id>.png con transparencia. Los textos van en crema con borde rojo
     para que se lean igual en una camiseta blanca, roja o negra. ---------- */
  function xmas(t, cx, cy, w, h, fuente, borde) { return texto(t, cx, cy, w, h, fuente, '#fff8e7', { borde: [borde || 0.12, '#b3202e'] }); }
  function foto(cx, cy, w, h, forma) {
    var o = hueco(cx, cy, w, h);
    if (forma === 'circulo') { o.difuminado = 100; o.difumEstilo = 'forma:circulo:' + Math.round(w * 40) + 'x' + Math.round(h * 40); }
    return o;
  }
  var CAMISETAS = [
    { id: 'cam-gracioso', nombre: 'Ponte un gorro de Navidad', nota: '1 foto con gorro de Papá Noel para todos los que salgan', f: function () { return { vista: 'pecho-libre', pista: 'Elige una foto en la que se vean bien las caras. En el paso siguiente la encuadras y la IA le pone el gorro a todos los que salgan.', colocar: true, elementos: [
      foto(15, 16.8, 26, 26), arte('gorro', 16.8, 6.2, 14, 11.24, 7),
      xmas('Feliz Navidad', 15, 34.6, 26, 4.4, F.lobster, 0.14)] }; } },
    { id: 'cam-cascarrabias', nombre: 'Cascarrabias, gruñón de Navidad', nota: '1 foto convertida en un gruñón verde de Navidad', f: function () { return { vista: 'pecho-libre', pista: 'Elige una foto con las personas bien visibles. En el paso siguiente la IA las convierte en gruñones verdes de Navidad.', colocar: true,
      efecto: { estilo: 'cascarrabias', boton: '😠 Convertirme en cascarrabias', haciendo: 'Poniéndote de mal humor…', icono: '😠🎄', espera: 'Convirtiéndote en cascarrabias…', nota: 'La IA de OpenAI te convierte en un cascarrabias verde de Navidad, a ti y a todas las personas que salgan. La foto no se guarda.' }, elementos: [
      foto(15, 16.8, 26, 26),
      xmas('Cascarrabias de Navidad', 15, 34.6, 27, 4.0, F.lobster, 0.14)] }; } },
    { id: 'cam-dibujos', nombre: 'Tú en dibujos animados', nota: '1 foto convertida en dibujos animados', f: function () { return { vista: 'pecho-libre', pista: 'Elige una foto con las personas bien visibles. En el paso siguiente la IA la convierte en dibujos animados.', colocar: true,
      efecto: { estilo: 'animacion3d-navidad', boton: '🎨 Convertirme en dibujos animados', haciendo: 'Dibujándote…', icono: '🎨🎄', espera: 'Convirtiéndote en dibujo animado…', nota: 'La IA de OpenAI convierte tu foto en dibujos animados, con todas las personas que salgan. La foto no se guarda.' }, elementos: [
      foto(15, 16.8, 26, 26),
      xmas('Feliz Navidad', 15, 34.6, 26, 4.4, F.lobster, 0.14)] }; } },
    { id: 'cam-animacion', nombre: 'Tú en animación 3D', nota: '1 foto convertida en un personaje de película de animación', f: function () { return { vista: 'pecho-libre', pista: 'Elige una foto con las personas bien visibles. En el paso siguiente la IA la convierte en un personaje de película de animación 3D.', colocar: true,
      efecto: { estilo: 'animacion3d', boton: '🎨 Convertirme en animación 3D', haciendo: 'Dibujándote…', icono: '🎨✨', espera: 'Convirtiéndote en personaje de animación 3D…', nota: 'La IA de OpenAI convierte tu foto en un personaje de película de animación 3D, con todas las personas que salgan. La foto no se guarda.' }, elementos: [
      foto(15, 16.8, 26, 26),
      texto('Tu nombre', 15, 34.2, 26, 4.4, F.lobster, '#ffffff')] }; } },
    { id: 'cam-reno', nombre: 'Reno de Navidad con nariz roja', nota: '1 foto convertida en reno de Navidad', f: function () { return { vista: 'pecho-libre', pista: 'Elige una foto con las personas bien visibles. En el paso siguiente la IA les pone cuernos de reno y la nariz roja.', colocar: true,
      efecto: { estilo: 'reno', boton: '🦌 Convertirme en reno', haciendo: 'Poniéndote los cuernos…', icono: '🦌🎄', espera: 'Convirtiéndote en reno de Navidad…', nota: 'La IA de OpenAI te pone cuernos de reno y la nariz roja, a ti y a todas las personas que salgan. La foto no se guarda.' }, elementos: [
      foto(15, 16.8, 26, 26),
      xmas('Feliz Navidad', 15, 34.6, 26, 4.4, F.lobster, 0.14)] }; } },
  ];
  var TEMAS = {
    'cam-navidad': { t: 'Elige tu ' + PROD + ' de Navidad', s: 'Toca un diseño, luego pon tus fotos y cambia el nombre.', ids: ['cam-gracioso', 'cam-dibujos', 'cam-cascarrabias', 'cam-reno'] },
    fotos: { t: 'Elige cómo quieres tu taza', s: 'Toca un montaje, luego pon tus fotos y tu nombre. Se ve la taza entera, de lado a lado.',
      ids: ['todo', 'nombre', 'lados', 'lados-nombre', 'fnl', 'c3', 'c4', 'c5', 'c6', 'c8', 'c10'] },
    navidad: { t: 'Elige tu taza de Navidad', s: 'Toca un diseño, luego pon tus fotos y cambia el nombre.', ids: ['navidad-feliz', 'navidad-foto', 'navidad-collage', 'navidad-primera', 'todo', 'nombre'] },
    mama: { t: 'Elige tu taza para mamá', s: 'Toca un diseño, luego pon tus fotos y cambia los textos.', ids: ['mama', 'mama-letras', 'mejor-mama', 'madres', 'todo', 'nombre'] },
    papa: { t: 'Elige tu taza para papá', s: 'Toca un diseño, luego pon tus fotos y cambia los textos.', ids: ['papa', 'papa-letras', 'mejor-papa', 'mejor-papa-foto', 'legend', 'rey', 'todo', 'nombre'] },
    abuelos: { t: 'Elige tu taza para abuelos', s: 'Toca un diseño, luego pon tu foto y cambia los textos.', ids: ['abuela', 'abuelo', 'todo', 'nombre'] },
    pareja: { t: 'Elige tu taza para parejas', s: 'Toca un diseño, luego pon vuestras fotos y cambia los nombres.', ids: ['amor', 'amor-letras', 'love', 'youyme', 'valentin-quiero', 'valentin-foto', 'pareja', 'nombres', 'todo'] },
    cumple: { t: 'Elige tu taza de cumpleaños', s: 'Toca un diseño, luego pon tus fotos y cambia los textos.', ids: ['anio', 'cumple', 'frase', 'todo', 'nombre'] },
    letras: { t: 'Tu nombre en fotos', s: 'Escribe el nombre y elige el color. Luego pones tus fotos.', ids: [], letras: true },
    amigo: { t: 'Elige tu taza de amigo invisible', s: 'Toca un diseño, luego pon la foto y escribe el nombre de tu amigo invisible.', ids: ['ai-regalo', 'ai-misterio', 'ai-divertida', 'friends', 'nombre', 'todo'] },
    reyes: { t: 'Elige tu taza de Reyes', s: 'Toca un diseño, luego pon la foto y cambia los textos.', ids: ['reyes-carta', 'reyes-foto', 'reyes-corona', 'nombre', 'todo'] },
    nombre: { t: 'Elige tu taza con nombre', s: 'Toca un diseño y escribe el nombre que quieras.', ids: ['inicial', 'inicial-azul', 'inicial-rosa', 'nombres', 'nombre'] }
  };
  function claveTema() { return CAM ? 'cam-' + window.IMP_CAMISETA_TEMA : window.IMP_TAZA_TEMA; }
  function montaje(id) {
    var i, L = COMPOSICIONES.concat(PLANTILLAS, CAMISETAS);
    for (i = 0; i < L.length; i++) if (L[i].id === id) return L[i];
    return null;
  }
  /* Nombre en fotos (Xavi, 25/10/2026): se escribe el nombre (2-6 letras o cifras) y se monta solo: cada letra en una casilla de color y, entre
     ellas, huecos para fotos, en zigzag y repartido entre las dos caras. Un solo paso: nombre, color y «Crear mi taza». */
  var ESTILOS_LETRAS = [
    { id: 'rosa', nombre: 'Rosa', c: ['#e58aa3'], fondo: '#fff4f6' },
    { id: 'azul', nombre: 'Azul', c: ['#4f87d9'], fondo: '#f1f6ff' },
    { id: 'verde', nombre: 'Verde', c: ['#2f9e5b'], fondo: '#f2faf5' },
    { id: 'multi', nombre: 'Varios colores', c: ['#e58aa3', '#4f87d9', '#f2b84b', '#2f9e5b', '#8e6bc4', '#e8605a'], fondo: '#ffffff' }
  ];
  function limpiaNombre(t) { return String(t || '').toUpperCase().replace(/[^A-ZÁÉÍÓÚÜÑ0-9]/g, '').slice(0, 8); }
  function letrasPlantilla(palabra, estilo) { return letrasMontaje(palabra, function (i) { return estilo.c[i % estilo.c.length]; }, F.gruesa, fondo(estilo.fondo)); }
  /* Vista con la que se abre un montaje: la primera (lado izquierdo), salvo que lleve una foto panorámica (un hueco de más de 10 cm, de lado a lado) o sea el
     nombre en fotos, que ocupa toda la taza: entonces, la panorámica (Xavi, 25/10/2026). */
  function vistaDe(ctrl, est, completo) {
    if (CAM) return 'pecho-libre';
    if (completo || est.elementos.some(function (e) { return e.hueco && e.w > 10; })) return 'panoramica';
    return primeraVista(ctrl);
  }
  function primeraVista(ctrl) { var v = ctrl.vistas; try { if (typeof v === 'function') v = v(); } catch (e) { v = null; } return (v && v[0] && v[0].id) || 'izquierda'; }
  function abrirLetras(ctrl) {
    cerrar(); cargarFuentes();
    var tema = TEMAS.letras, estilo = ESTILOS_LETRAS[0];
    var v = document.createElement('div'); v.className = 'tzp tzp--pleno tzp--letras'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); v.setAttribute('aria-label', tema.t);
    var c = document.createElement('div'); c.className = 'tzp__c';
    c.innerHTML = '<div class="tzp__cab"><div><p class="tzp__t"></p><p class="tzp__s"></p></div><button type="button" class="tzp__x" aria-label="Cerrar">×</button></div>' +
      '<label class="tzl__l" for="tzl-nombre">Escribe el nombre</label>' +
      '<input id="tzl-nombre" class="tzl__in" type="text" inputmode="text" maxlength="8" autocomplete="off" autocapitalize="characters" placeholder="MAMÁ">' +
      '<p class="tzl__a">De 2 a 8 letras o cifras (por ejemplo MAMÁ, ABUELA o 2026).</p>' +
      '<p class="tzl__l">Elige el color</p><div class="tzl__col" data-col></div>' +
      '<div class="tzl__vista" data-vista></div>' +
      '<button type="button" class="tzl__ok" data-ok>Crear mi taza</button>';
    c.querySelector('.tzp__t').textContent = tema.t; c.querySelector('.tzp__s').textContent = tema.s;
    var inp = c.querySelector('#tzl-nombre'), col = c.querySelector('[data-col]'), vista = c.querySelector('[data-vista]'), ok = c.querySelector('[data-ok]');
    function pintaVista() {
      var pal = limpiaNombre(inp.value); if (pal.length < 2) pal = 'MAMÁ';
      calidad = 'mini'; var est = letrasPlantilla(pal, estilo); calidad = 'alta';
      vista.innerHTML = ''; var m = miniatura(est), k = Math.min(4, (vista.clientWidth || 300) / (W * PX));
      m.style.transformOrigin = '0 0'; m.style.transform = 'scale(' + k + ')'; vista.style.height = (H * PX * k) + 'px'; vista.appendChild(m);
    }
    ESTILOS_LETRAS.forEach(function (e, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tzl__c' + (i === 0 ? ' is-on' : ''); b.title = e.nombre; b.setAttribute('aria-label', e.nombre);
      b.style.background = e.c.length > 1 ? 'linear-gradient(90deg,' + e.c.slice(0, 4).join(',') + ')' : e.c[0];
      b.addEventListener('click', function () { estilo = e; [].forEach.call(col.children, function (x) { x.classList.toggle('is-on', x === b); }); pintaVista(); });
      col.appendChild(b);
    });
    inp.addEventListener('input', function () { var l = limpiaNombre(inp.value); if (inp.value !== l) inp.value = l; ok.disabled = l.length < 2; pintaVista(); });
    ok.disabled = true;
    function crear() {
      var pal = limpiaNombre(inp.value); if (pal.length < 2) { inp.focus(); return; }
      if (ctrl.hayDiseño && ctrl.hayDiseño() && !window.confirm('Este diseño sustituye lo que ya has puesto en la ' + PROD + '. ¿Continuar?')) return;
      var est = letrasPlantilla(pal, estilo); est.vista = vistaDe(ctrl, est, true); cerrar(); ctrl.plantilla(est);
      aviso('Toca cada cámara para poner tu foto.');
    }
    ok.addEventListener('click', crear);
    inp.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); crear(); } });
    c.querySelector('.tzp__x').addEventListener('click', cerrar);
    v.addEventListener('click', function (ev) { if (ev.target === v) cerrar(); });
    v.appendChild(c); document.body.appendChild(v); abierta = v; document.documentElement.classList.add('tz-pleno');
    document.addEventListener('keydown', alTeclear);
    setTimeout(pintaVista, 0);
  }
  /* Asistente de montaje (Xavi, 25/10/2026): «al elegir una plantilla sale un formulario que pide las fotos y el texto, y sale la taza montada. Si le gusta, adelante;
     si no, la modifica. Muchos clientes no saben usar el editor y piden que lo haga yo». Pasos: 1) las fotos (todas de una vez), 2) los nombres, 3) la taza montada
     con «Me gusta, seguir» o «Cambiar algo». */
  /* Los nombres que pide el asistente: cada «Nombre» (o «Nombres») que lleva un texto del montaje es una ranura. Se cuentan por cara: lo que se repite en las dos
     caras (el mismo nombre dos veces) es una sola ranura, y dos nombres en la misma cara («Nombre & Nombre») son dos. Un texto con `pide` (p. ej. «marc») se cambia entero. */
  function ranurasNombre(elementos) {
    var cuenta = [0, 0], items = [];
    elementos.forEach(function (e) {
      if (e.tipo !== 'texto') return;
      var cara = e.cx < 10 ? 0 : 1;
      if (e.pide) items.push({ e: e, ranuras: [cuenta[cara]++], entero: true });
      else { var m = String(e.texto).match(/nombres?/gi); if (m) { var r = []; m.forEach(function () { r.push(cuenta[cara]++); }); items.push({ e: e, ranuras: r }); } }
    });
    return { items: items, n: Math.max(cuenta[0], cuenta[1]) };
  }
  /* PC (Xavi, 25/10/2026): «el formulario en la columna de la derecha: que suban todas las fotos y textos que pida la plantilla». Panel «Personaliza» sobre
     «¿Cuántas quieres?»: una fila por foto (miniatura + «Subir foto»/«Cambiar foto») y un campo por nombre; los cambios se ven al momento en la taza. */
  function quitarPanelPC() { var q = document.querySelector('.tzpc'); if (q) q.remove(); }
  function panelPC(ctrl, est0) {
    quitarPanelPC();
    if (esMovil()) return;
    var paso = document.querySelector('.rop-t'); paso = paso && paso.closest('.rop-paso'); if (!paso) return;
    var els = ctrl.elementos(), hs = els.filter(function (e) { return e.hueco || e.deHueco; }), rn = ranurasNombre(est0.elementos), n, i;
    if (!hs.length && !rn.n) return;
    var tEst = est0.elementos.filter(function (e) { return e.tipo === 'texto'; }), tVivos = els.filter(function (e) { return e.tipo === 'texto'; });   // mismo orden: cada texto del montaje y su elemento vivo
    var base = rn.items.map(function (it) { var vivo = tVivos[tEst.indexOf(it.e)]; return { it: { e: vivo, ranuras: it.ranuras, entero: it.entero }, orig: String(it.e.texto) }; });
    var d = document.createElement('div'); d.className = 'tzpc'; d.innerHTML = '<p class="tzpc__t">Personaliza</p>';
    if (est0.pista) { var pi = document.createElement('p'); pi.className = 'tzpc__pista'; pi.textContent = est0.pista; d.appendChild(pi); }
    function fila(tit) { var f = document.createElement('div'); f.className = 'tzpc__f'; f.innerHTML = '<span class="tzpc__l"></span>'; f.firstChild.textContent = tit; d.appendChild(f); return f; }
    hs.forEach(function (h, k) {
      var f = fila(hs.length > 1 ? 'Foto ' + (k + 1) : 'Tu foto'), th = document.createElement('span'); th.className = 'tzpc__th'; th.textContent = '📷'; f.appendChild(th);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tzpc__b'; b.textContent = '📷 Subir foto'; f.appendChild(b);
      var inp = document.createElement('input'); inp.type = 'file'; inp.accept = 'image/*'; inp.style.display = 'none'; f.appendChild(inp);
      b.addEventListener('click', function () { inp.value = ''; inp.click(); });
      inp.addEventListener('change', function () {
        var fl = inp.files && inp.files[0]; if (!fl) return;
        ctrl.rellenarHueco(k, fl); th.textContent = ''; var im = document.createElement('img'); im.alt = ''; im.src = URL.createObjectURL(fl); th.appendChild(im); b.textContent = '📷 Cambiar foto';
      });
    });
    for (n = 0; n < rn.n; n++) (function (n) {
      var f = fila(rn.n > 1 ? 'Nombre ' + (n + 1) : 'Tu nombre'), t = document.createElement('input'); t.type = 'text'; t.className = 'tzpc__i'; t.maxLength = 24; t.autocomplete = 'off'; t.placeholder = 'Nombre'; f.appendChild(t);
      t.addEventListener('input', function () {
        var v = t.value.trim();
        base.forEach(function (x) {
          var el = x.it.e, j = 0; if (x.it.ranuras.indexOf(n) < 0) return;
          var cur = x.it.entero ? (v || x.orig) : x.orig.replace(/nombres?/gi, function (m) { var r = x.it.ranuras[j++]; return r === n ? (v || m) : (valorPC[r] || m); });
          valorPC[n] = v; if (!el.t) return; el.t.textContent = cur; el.ejemplo = false; if (el.aplicar) el.aplicar();
        });
        valorPC[n] = v;
      });
    })(n);
    var valorPC = {};
    paso.parentNode.insertBefore(d, paso);
  }
  /* Colocar la cara (Xavi, 26/10/2026): la foto se arrastra dentro del círculo (y con dos dedos o el deslizador se amplía) hasta que la cara cae en el óvalo,
     y el gorro se arrastra hasta la cabeza. Todo en cm de la superficie: la escena es un cuadrado de L cm centrado en el círculo. Sin IA ni detección de caras. */
  function colocador(cont, url, hueco, hat, pan, gorro, raiz, col, fotos) {
    var L = hueco.w * 1.45, x0 = hueco.cx - L / 2, y0 = hueco.cy - 1.5 - L / 2, im = new Image(), S = 0, ar = hat ? hat.h / hat.w : 1, EF = col.ef;
    cont.innerHTML = '<div class="tzcol__c"><div class="tzcol__f"><img alt="" draggable="false"></div></div><svg class="tzcol__g" viewBox="0 0 100 100" aria-hidden="true"></svg><img class="tzcol__h" alt="" draggable="false">';
    var fc = cont.querySelector('.tzcol__c'), fi = fc.querySelector('img'), g = cont.querySelector('.tzcol__g'), h = cont.querySelector('.tzcol__h');
    var rc = hueco.w / L * 100, cx = (hueco.cx - x0) / L * 100, cy = (hueco.cy - y0) / L * 100;
    fc.style.cssText = 'left:' + (cx - rc / 2) + '%;top:' + (cy - rc / 2) + '%;width:' + rc + '%;height:' + rc + '%';
    g.innerHTML = '<rect x="' + (cx - rc / 2) + '" y="' + (cy - rc / 2) + '" width="' + rc + '" height="' + rc + '" fill="none" stroke="#17171a" stroke-width=".5"/>';
    if (hat) h.src = urlArte('gorro');
    function pintaGorro() { if (!gorro) return; h.style.cssText = 'left:' + (gorro.cx - x0) / L * 100 + '%;top:' + (gorro.cy - y0) / L * 100 + '%;width:' + gorro.w / L * 100 + '%;transform:translate(-50%,-50%) rotate(' + gorro.rot + 'deg)'; }
    function lado() { var s = Math.min(im.naturalWidth, im.naturalHeight) / pan.z; return s; }
    function pintaFoto() {
      if (!im.naturalWidth) return;
      var Sc = fc.clientWidth, s = lado(), sx = (im.naturalWidth - s) * pan.fx, sy = (im.naturalHeight - s) * pan.fy;
      fi.style.cssText = 'width:' + im.naturalWidth * Sc / s + 'px;height:' + im.naturalHeight * Sc / s + 'px;left:' + (-sx * Sc / s) + 'px;top:' + (-sy * Sc / s) + 'px;transform-origin:' + (sx + s / 2) * Sc / s + 'px ' + (sy + s / 2) * Sc / s + 'px;transform:rotate(' + (pan.rot || 0) + 'deg)' + (pan.espejo ? ' scaleX(-1)' : '') + ';';
    }
    function cargar(u) { im.onload = function () { fi.src = u; pintaFoto(); }; im.src = u; }
    cargar(url); pintaGorro();
    function limita() { pan.fx = Math.max(0, Math.min(1, pan.fx)); pan.fy = Math.max(0, Math.min(1, pan.fy)); }
    var pts = {}, modo = null, ini = null;
    cont.addEventListener('pointerdown', function (ev) {
      if (col.ia) return;   // con la IA ya aplicada, el encuadre se cambia con «Cambiar encuadre»
      pts[ev.pointerId] = { x: ev.clientX, y: ev.clientY }; try { cont.setPointerCapture(ev.pointerId); } catch (e) { /* sin captura */ }
      var n = Object.keys(pts).length;
      S = cont.clientWidth;
      if (n === 1) { modo = ev.target === h ? 'gorro' : 'foto'; ini = { x: ev.clientX, y: ev.clientY, fx: pan.fx, fy: pan.fy, cx: gorro ? gorro.cx : 0, cy: gorro ? gorro.cy : 0 }; }
      else if (n === 2) { var k = Object.keys(pts), a = pts[k[0]], b = pts[k[1]]; modo = 'pinza'; ini = { d: Math.hypot(a.x - b.x, a.y - b.y), z: pan.z, ang: Math.atan2(b.y - a.y, b.x - a.x), rot: pan.rot || 0 }; }
    });
    cont.addEventListener('pointermove', function (ev) {
      if (!pts[ev.pointerId]) return; pts[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
      if (modo === 'foto') {
        var Sc = fc.clientWidth, s = lado(), rx = im.naturalWidth - s, ry = im.naturalHeight - s, dx = ev.clientX - ini.x, dy = ev.clientY - ini.y;
        var ca = Math.cos((pan.rot || 0) * Math.PI / 180), sa = Math.sin((pan.rot || 0) * Math.PI / 180), ux = (dx * ca + dy * sa) * (pan.espejo ? -1 : 1), uy = -dx * sa + dy * ca;   // el arrastre, en los ejes de la foto girada
        pan.fx = rx > 0 ? ini.fx - (ux / Sc * s) / rx : 0.5; pan.fy = ry > 0 ? ini.fy - (uy / Sc * s) / ry : 0.5; limita(); pintaFoto();
      } else if (modo === 'gorro') {
        gorro.cx = ini.cx + (ev.clientX - ini.x) / S * L; gorro.cy = ini.cy + (ev.clientY - ini.y) / S * L; pintaGorro();
      } else if (modo === 'pinza') {
        var k = Object.keys(pts); if (k.length < 2) return; var a = pts[k[0]], b = pts[k[1]];
        pan.z = Math.max(1, Math.min(4, ini.z * Math.hypot(a.x - b.x, a.y - b.y) / (ini.d || 1))); var zi = raiz.querySelector('[data-z]'); if (zi) zi.value = Math.round(pan.z * 100); /* sin girar con dos dedos: el encuadre es solo mover y ampliar (Xavi, 26/10/2026) */ var fr = raiz.querySelector('[data-f]'); if (fr) fr.value = Math.round(pan.rot); limita(); pintaFoto();
      }
    });
    function suelta(ev) { delete pts[ev.pointerId]; if (!Object.keys(pts).length) modo = null; else if (Object.keys(pts).length === 1) { var k = Object.keys(pts)[0]; modo = 'foto'; ini = { x: pts[k].x, y: pts[k].y, fx: pan.fx, fy: pan.fy, cx: gorro ? gorro.cx : 0, cy: gorro ? gorro.cy : 0 }; } }
    cont.addEventListener('pointerup', suelta); cont.addEventListener('pointercancel', suelta);

    /* «Ponerme el gorro con IA» (Xavi, 26/10/2026): la IA de imágenes devuelve la foto con un gorro puesto a cada persona; después solo se centra la foto en el círculo.
       Sin gorro a mano (Xavi, 26/10/2026). Máximo 2 intentos por pedido (y el Worker pone sus topes). */
    var API = (window.FOTOIA_URL || 'https://fotoia-elcajonfriki.imprimirlo.workers.dev').replace(/\/$/, '');
    var bia = raiz.querySelector('[data-ia]'), msg = raiz.querySelector('[data-msg]');
    var bvu = raiz.querySelector('[data-vuelta]'), ctrls = raiz.querySelectorAll('[data-zoom]');
    function ponGorro() {
      h.style.display = 'none';   // el gorro lo pone siempre la IA (Xavi, 26/10/2026: «todo con IA y listo»)
      bia.textContent = col.ia ? '🔁 Probar otra vez' : (EF ? EF.boton : '🎅 Ponerle el Gorro');
      bvu.hidden = !col.ia;
      [].forEach.call(ctrls, function (e) { e.style.display = col.ia ? 'none' : ''; });   // ya encuadrada y con IA: los controles de la foto se esconden
    }
    /* El recorte que se ve en el círculo (con el zoom, el giro y el espejo elegidos): es lo que se manda a la IA, así recorta lo que el cliente quiera quitar */
    function recorteActual() {
      var s = lado(), sx = (im.naturalWidth - s) * pan.fx, sy = (im.naturalHeight - s) * pan.fy, k = Math.min(1, 1024 / s), c = document.createElement('canvas'), q = c.getContext('2d');
      c.width = c.height = Math.max(1, Math.round(s * k));
      q.fillStyle = '#fff'; q.fillRect(0, 0, c.width, c.height);
      q.translate(c.width / 2, c.height / 2); q.rotate((pan.rot || 0) * Math.PI / 180); if (pan.espejo) q.scale(-1, 1);
      q.drawImage(im, -(sx + s / 2) * k, -(sy + s / 2) * k, im.naturalWidth * k, im.naturalHeight * k);
      return c.toDataURL('image/jpeg', 0.88);
    }
    function reiniciaFoto(fy) {
      pan.fx = 0.5; pan.fy = fy; pan.z = 1; pan.rot = 0; pan.espejo = false;
      var q;
      if ((q = raiz.querySelector('[data-z]'))) q.value = 100;
      if ((q = raiz.querySelector('[data-f]'))) q.value = 0;
      if ((q = raiz.querySelector('[data-e]'))) q.classList.remove('is-on');
    }
    function espera(on, texto) {   // el «procesando» común de todos los procesos de IA (assets/proceso-ia.js: barras verdes sobre pantalla oscura)
      if (window.ProcesoIA) { if (on) window.ProcesoIA.mostrar(texto, 'La IA puede tardar hasta un minuto. No cierres esta pantalla.'); else window.ProcesoIA.ocultar(); return; }
      var e = document.getElementById('tzespera');
      if (!on) { if (e) e.remove(); return; }
      if (!document.getElementById('tzespera-css')) { var st = document.createElement('style'); st.id = 'tzespera-css'; st.textContent = '#tzespera{position:fixed;inset:0;z-index:99999;background:rgba(34,34,34,.96);color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2rem;text-align:center;padding:2rem}#tzespera b{font-size:7rem;line-height:1;animation:tzpar 1s ease-in-out infinite}#tzespera p{margin:0;font-size:2.2rem;font-weight:700}#tzespera small{font-size:1.5rem;opacity:.75}@keyframes tzpar{0%,100%{opacity:1}50%{opacity:.15}}'; document.head.appendChild(st); }
      if (!e) { e = document.createElement('div'); e.id = 'tzespera'; e.setAttribute('role', 'status'); e.innerHTML = '<b></b><p></p><small>La IA puede tardar hasta un minuto. No cierres esta pantalla.</small>'; document.body.appendChild(e); }
      e.querySelector('b').textContent = EF && EF.icono || '🎅🎄'; e.querySelector('p').textContent = texto;
    }
    ponGorro();
    bia.addEventListener('click', function () {
      if (bia.disabled || !im.naturalWidth) return;
      if (col.intentos >= 2) { msg.textContent = 'Ya has usado tus 2 intentos. Si quieres otro encuadre, pulsa «Cambiar encuadre» y sube otra foto.'; return; }
      var dato = col.ia && col.recorte ? col.recorte : recorteActual();   // la primera vez, lo que se ve en el círculo; al «Probar otra vez», el mismo recorte
      if (!col.ia) { col.recorte = dato; col.encuadre = { fx: pan.fx, fy: pan.fy, z: pan.z, rot: pan.rot, espejo: pan.espejo }; }
      bia.disabled = true; bvu.disabled = true; bia.textContent = EF ? EF.haciendo : 'Poniéndote el gorro…'; msg.textContent = 'La IA de OpenAI está creando tu foto. Puede tardar hasta un minuto; no cierres esta pantalla.';
      espera(true, EF ? EF.espera || EF.haciendo : 'Poniéndote el gorro de Navidad…');
      var ctl = new AbortController(), to = setTimeout(function () { ctl.abort(); }, 150000);
      fetch(API + (EF ? '/api/foto' : '/api/gorro'), { method: 'POST', signal: ctl.signal, headers: { 'content-type': 'application/json' }, body: JSON.stringify(EF ? { imagen: dato, estilo: EF.estilo, acepto: true } : { imagen: dato, forma: 'cuadrada', acepto: true }) })
        .then(function (rs) { return rs.json().then(function (j) { j._st = rs.status; return j; }); })
        .then(function (j) {
          if (!j.ok) throw new Error(j._st === 404 || j._st === 403 || !j.error ? 'Ahora mismo no se puede usar la IA. Inténtalo en unos minutos.' : j.error);
          return fetch(j.imagen).then(function (x) { return x.blob(); });
        })
        .then(function (bl) {
          var f = new File([bl], EF ? 'efecto-ia.png' : 'gorro-ia.jpg', { type: EF ? 'image/png' : 'image/jpeg' }); f._u = URL.createObjectURL(f);
          col.intentos++; col.ia = true; fotos[0] = f; reiniciaFoto(0.5); cargar(f._u); ponGorro();
          if (window.Montajes && col.mj) { window.Montajes.guardar({ plantilla: col.mj.plantilla, nombre: col.mj.nombre, ocasion: col.mj.ocasion, archivo: bl }); window.Montajes.marcarPagina(); }   // el montaje queda guardado: «Tu montaje» lo enseña en todos los productos   // el resultado ya es el recorte elegido, entero en el círculo
          if (col.alTerminar) { msg.textContent = '¡Listo! Montando tu ' + PROD + '…'; espera(true, '¡Listo! Montando tu ' + PROD + '…'); bia.disabled = true; setTimeout(col.alTerminar, 900); return; }
          msg.textContent = '¡Listo!' + (col.intentos < 2 ? ' Si no te gusta, puedes probar otra vez.' : '') + ' Con «Cambiar encuadre» vuelves a tu foto.';
        })
        .catch(function (e) { msg.textContent = (e && e.name === 'AbortError') ? 'Está tardando demasiado. Vuelve a pulsar el botón.' : (e && e.message && !/fetch|network|json|load/i.test(e.message)) ? e.message : 'No se ha podido usar la IA. Vuelve a pulsar el botón.'; })
        .then(function () { clearTimeout(to); if (col.ia && col.alTerminar) return; espera(false); bia.disabled = false; bvu.disabled = false; ponGorro(); });
    });
    bvu.addEventListener('click', function () {
      if (bia.disabled) return;
      col.ia = false; col.recorte = null; fotos[0] = col.orig; var e0 = col.encuadre || {}; pan.fx = e0.fx != null ? e0.fx : 0.5; pan.fy = e0.fy != null ? e0.fy : 0.5; pan.z = e0.z || 1; pan.rot = e0.rot || 0; pan.espejo = !!e0.espejo;
      var q; if ((q = raiz.querySelector('[data-z]'))) q.value = Math.round(pan.z * 100); if ((q = raiz.querySelector('[data-f]'))) q.value = pan.rot; if ((q = raiz.querySelector('[data-e]'))) q.classList.toggle('is-on', pan.espejo);
      cargar(col.orig._u); ponGorro(); msg.textContent = 'Encuadra tu foto otra vez y pulsa el botón de la IA.';
    });
    function zoom(d) { pan.z = Math.max(1, Math.min(4, Math.round((pan.z + d) * 100) / 100)); limita(); pintaFoto(); }
    var zm = raiz.querySelector('[data-zm]'), zp = raiz.querySelector('[data-zp]');
    if (zm) zm.addEventListener('click', function () { zoom(-0.25); });
    if (zp) zp.addEventListener('click', function () { zoom(0.25); });
    cont.addEventListener('wheel', function (ev) { if (col.ia) return; ev.preventDefault(); zoom(ev.deltaY < 0 ? 0.15 : -0.15); }, { passive: false });
  }
  function asistenteMontaje(ctrl, p, solo) {   // solo = {volver, destino}: el montaje se hace en su propia página (desde una ocasión) y al terminar va a «Tu montaje»
    cerrar();
    var est = p.f(), huecos = est.elementos.filter(function (e) { return e.hueco; }), rn = ranurasNombre(est.elementos), nombres = [], k0;
    for (k0 = 0; k0 < rn.n; k0++) nombres.push({ texto: 'Nombre' });
    var fotos = [], valores = nombres.map(function () { return ''; }), pasos = [];
    var pan = null, gorro = null, gorroEl = null, huecoEl = huecos[0], pans = [], col = { ia: false, intentos: 0, orig: null, ef: p.f().efecto || null, mj: { plantilla: p.id, nombre: p.nombre, ocasion: (function () { var o = (/[?&]o=([a-z-]+)/.exec(location.search) || [])[1]; return o === 'madre' || o === 'san-valentin' ? o : 'navidad'; })() } };
    if (est.colocar) { gorroEl = est.elementos.filter(function (e) { return e.src === 'art:gorro'; })[0]; gorro = !gorroEl ? null : { cx: gorroEl.cx, cy: gorroEl.cy, w: gorroEl.w, rot: gorroEl.rot || 0 }; pan = { fx: 0.5, fy: 0.5, z: 1, rot: 0, espejo: false }; pans = [pan]; }
    if (huecos.length) pasos.push('fotos');
    if (est.colocar) pasos.push('colocar');
    if (nombres.length) pasos.push('textos');
    function montar(directo, pc) {
      var e2 = p.f(), r2 = ranurasNombre(e2.elementos);
      r2.items.forEach(function (it) {
        var texto0 = String(it.e.texto), j = 0;
        if (it.entero) { var v = (valores[it.ranuras[0]] || '').trim(); if (v) it.e.texto = v; return; }
        it.e.texto = texto0.replace(/nombres?/gi, function (m) { var v = (valores[it.ranuras[j++]] || '').trim(); return v || m; });
      });
      if (est.colocar && col.ia) e2.elementos = e2.elementos.filter(function (e) { return e.src !== 'art:gorro'; });   // la IA ya le puso el gorro a la foto
      else if (est.colocar && gorro && fotos[0]) e2.elementos.forEach(function (e) { if (e.src === 'art:gorro') { e.cx = gorro.cx; e.cy = gorro.cy; e.w = gorro.w; e.h = gorro.w * gorroEl.h / gorroEl.w; e.rot = gorro.rot; } });
      var n1 = (valores[0] || '').trim();
      if (n1) e2.elementos.forEach(function (e) { if (e.inicial) e.texto = n1.charAt(0).toUpperCase(); });   // la letra grande de «Inicial y nombre»
      cerrar();
      resolverFondos(e2).then(function (e3) {
        e3.vista = vistaDe(ctrl, e3, false); ctrl.plantilla(e3);
        if (!directo) { if (ctrl.rellenarHuecos) ctrl.rellenarHuecos(fotos, pans); fin(); }
        else { if (pc) panelPC(ctrl, e3); aviso(huecos.length ? 'Sube tu foto y escribe tu nombre en el panel «Personaliza», o toca la ' + PROD + '.' : 'Escribe tu nombre en el panel «Personaliza».'); }
      });
    }
    if (!pasos.length || (!esMovil() && !est.colocar)) return montar(true, !esMovil());   // el formulario es solo para el móvil; en PC se monta la plantilla y se edita directamente (Xavi, 25/10/2026)
    var paso = 0;
    var v = document.createElement('div'); v.className = 'tzw'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); v.setAttribute('aria-label', p.nombre);
    document.body.appendChild(v); abierta = v; document.documentElement.classList.add('tz-pleno'); document.addEventListener('keydown', alTeclear);
    function fin() {
      var b = document.createElement('div'); b.className = 'tzw__fin';
      b.innerHTML = '<p>¿Te gusta cómo queda? Toca cualquier foto o texto para cambiarlo.</p><div><button type="button" class="tzw__ok" data-si>✓ Me gusta, seguir</button><button type="button" class="tzw__no" data-no>Cambiar algo</button></div>';
      document.body.appendChild(b);
      b.querySelector('[data-no]').addEventListener('click', function () { b.remove(); });
      b.querySelector('[data-si]').addEventListener('click', function () { b.remove(); var c = document.querySelector('.rop-libre-rail__b--comprar'); if (c) c.click(); });
    }
    function cuerpo() {
      var tipo = pasos[paso], ultimo = paso === pasos.length - 1, h = '';
      var sinSig = tipo === 'fotos' && huecos.length === 1 && !fotos[0];   // una sola foto: al elegirla se pasa sola al siguiente paso (Xavi, 26/10/2026)
      v.classList.toggle('tzw--col', tipo === 'colocar');
      if (tipo === 'colocar' && !fotos[0]) { paso++; return cuerpo(); }   // sin foto no hay nada que colocar
      h += '<div class="tzw__cab"><span class="tzw__p">Paso ' + (paso + 1) + ' de ' + pasos.length + '</span><button type="button" class="tzp__x" aria-label="Cerrar" data-x>×</button></div>';
      if (tipo === 'fotos') {
        var n = huecos.length;
        h += '<h2 class="tzw__t">' + (n > 1 ? 'Elige tus ' + n + ' fotos' : 'Elige tu foto') + '</h2><p class="tzw__s">' + (n > 1 ? 'Puedes elegirlas todas de una vez. Salen en la ' + PROD + ' en este orden.' : (est.pista || 'La puedes mover y ampliar después.')) + '</p><button type="button" class="tzw__sel" data-todas>' + (n > 1 ? '📷 Elegir mis fotos' : '📷 Elegir mi foto') + '</button><div class="tzw__fotos">';
        for (var i = 0; i < n; i++) h += '<button type="button" class="tzw__f' + (fotos[i] ? ' is-on' : '') + '" data-f="' + i + '" aria-label="Foto ' + (i + 1) + '">' + (fotos[i] ? '<img alt="" src="' + fotos[i]._u + '">' : '<span aria-hidden="true">📷</span>') + '<b>' + (i + 1) + '</b></button>';
        h += '</div>';
      } else if (tipo === 'colocar') {
        h += '<h2 class="tzw__t">Encuadra tu foto</h2><p class="tzw__s">Arrastra la foto y usa el zoom para recortar lo que quieras. Lo que se ve en el recuadro es lo que se convierte.</p><div class="tzcol" data-col></div>' +
          '<div class="tzcol__zoom" data-zoom><button type="button" class="tzcol__zb" data-zm>🔍 − Alejar</button><button type="button" class="tzcol__zb" data-zp>🔍 + Acercar</button></div>' +
          '<button type="button" class="tzcol__ia" data-ia>' + (col.ef ? col.ef.boton : '🎅 Ponerle el Gorro') + '</button><button type="button" class="tzcol__vu" data-vuelta hidden>↩ Cambiar encuadre</button>' +
          '<p class="tzcol__nota" data-msg>' + (col.ef ? col.ef.nota : 'La foto se envía a OpenAI para ponerle el gorro; no se guarda.') + '</p>';
      } else {
        h += '<h2 class="tzw__t">' + (nombres.length > 1 ? 'Escribe los nombres' : '¿Qué nombre quieres?') + '</h2><p class="tzw__s">Es lo que sale escrito en la ' + PROD + '. Si no lo sabes aún, déjalo y lo cambias después.</p><div class="tzw__campos">';
        nombres.forEach(function (e, i) { h += '<label class="tzw__l" for="tzw-' + i + '">' + (nombres.length > 1 ? 'Nombre ' + (i + 1) : 'Nombre') + '</label><input id="tzw-' + i + '" class="tzl__in" type="text" maxlength="24" autocomplete="off" placeholder="' + String(e.texto).replace(/"/g, '') + '" value="' + (valores[i] || '').replace(/"/g, '&quot;') + '" data-t="' + i + '">'; });
        h += '</div>';
      }
      h += tipo === 'colocar' ? '' : '<div class="tzw__pie">' + (paso > 0 ? '<button type="button" class="tzw__no" data-atras>Atrás</button>' : (solo ? '<button type="button" class="tzw__no" data-volver>← Volver a los montajes</button>' : '<button type="button" class="tzw__no" data-solo>Prefiero montarlo yo</button>')) +
        (sinSig ? '' : '<button type="button" class="tzw__ok" data-sig>' + (ultimo ? 'Ver mi ' + PROD : 'Siguiente') + '</button>') + '</div>';   // el paso de la IA no lleva botones: al terminar pasa solo al editor (Xavi, 26/10/2026)
      v.innerHTML = '<div class="tzw__c">' + h + '</div>';
      v.querySelector('[data-x]').addEventListener('click', solo ? function () { location.href = solo.volver; } : cerrar);
      var bvol = v.querySelector('[data-volver]'); if (bvol) bvol.addEventListener('click', function () { location.href = solo.volver; });
      var bsig = v.querySelector('[data-sig]'); if (bsig) bsig.addEventListener('click', function () {
        if (ultimo) montar(false); else { paso++; cuerpo(); }
      });
      var at = v.querySelector('[data-atras]'); if (at) at.addEventListener('click', function () { paso--; cuerpo(); });
      var bsolo = v.querySelector('[data-solo]'); if (bsolo) bsolo.addEventListener('click', function () { montar(true); });
      if (tipo === 'colocar') { col.orig = col.orig || fotos[0]; col.alTerminar = function () { if (abierta !== v) return; if (solo) { cerrar(); location.href = solo.destino; } else montar(false); }; colocador(v.querySelector('[data-col]'), fotos[0]._u, huecoEl, gorroEl, pan, gorro, v, col, fotos); }
      else if (tipo === 'fotos') {
        var inp = document.createElement('input'); inp.type = 'file'; inp.accept = 'image/*'; inp.style.display = 'none'; v.appendChild(inp);
        var hacia = -1;   // la foto que se cambia; -1 = todas, en orden
        inp.addEventListener('change', function () {
          var files = [].slice.call(inp.files); if (!files.length) return;
          files.forEach(function (f) { f._u = URL.createObjectURL(f); });
          /* al tocar una casilla también se pueden elegir varias a la vez (Xavi, 25/10/2026): se reparten desde esa casilla hacia delante */
          var desde = hacia >= 0 ? hacia : 0;
          files.slice(0, huecos.length - desde).forEach(function (f, i) { fotos[desde + i] = f; });
          if (est.colocar) { col.ia = false; col.orig = null; col.recorte = null; }   // otra foto: se empieza de cero (los intentos de IA sí cuentan)
          if (huecos.length === 1 && !ultimo) paso++;   // con una sola foto no hace falta «Siguiente»: se pasa solo a «Coloca tu cara»
          cuerpo();
        });
        v.querySelector('[data-todas]').addEventListener('click', function () { hacia = -1; inp.multiple = huecos.length > 1; inp.value = ''; inp.click(); });
        [].forEach.call(v.querySelectorAll('[data-f]'), function (b) { b.addEventListener('click', function () { hacia = +b.dataset.f; inp.multiple = huecos.length - hacia > 1; inp.value = ''; inp.click(); }); });
      } else {
        [].forEach.call(v.querySelectorAll('[data-t]'), function (i) {
          i.addEventListener('input', function () { valores[+i.dataset.t] = i.value; });
          /* teclado abierto: el paso se compacta y el campo se pone a la vista (si no, los botones de abajo lo tapan) */
          i.addEventListener('focus', function () { v.classList.add('tzw--tec'); setTimeout(function () { try { i.scrollIntoView({ block: 'center' }); } catch (e) { /* sin scroll */ } }, 280); });
          i.addEventListener('blur', function () { setTimeout(function () { if (!v.contains(document.activeElement) || document.activeElement.tagName !== 'INPUT') v.classList.remove('tzw--tec'); }, 150); });
        });
        var pr = v.querySelector('[data-t]'); if (pr) setTimeout(function () { try { pr.focus(); } catch (e) { /* sin foco */ } }, 120);
      }
    }
    cuerpo();
  }
  /* Producto abierto desde «Tu montaje» (?montaje=1): se pone el montaje ya hecho sin pasar por el asistente ni gastar IA (Xavi, 26/10/2026) */
  function montajeDirecto(ctrl, m) {
    var p = CAMISETAS.filter(function (x) { return x.id === m.plantilla; })[0];
    if (!p) return false;
    var est = p.f(), file = new File([m.archivo], 'montaje.png', { type: m.tipo || 'image/png' }); file._u = URL.createObjectURL(file);
    est.elementos = est.elementos.filter(function (e) { return e.src !== 'art:gorro'; });   // la IA ya puso el gorro en la foto
    resolverFondos(est).then(function (e3) {
      e3.vista = vistaDe(ctrl, e3, false); ctrl.plantilla(e3);
      if (ctrl.rellenarHuecos) ctrl.rellenarHuecos([file], [{ fx: 0.5, fy: 0.5, z: 1, rot: 0, espejo: false }]);
      if (window.Montajes) window.Montajes.marcarPagina();
      aviso('Tu montaje «' + m.nombre + '» ya está puesto. Elige tallas y añade al carrito: después podrás pedir otro producto con el mismo montaje.');
    });
    return true;
  }
  var montajeUsado = false;
  function abrir(ctrl) {
    if (!montajeUsado && CAM && /[?&]montaje=1(&|$)/.test(location.search) && window.Montajes) {
      montajeUsado = true;
      window.Montajes.leer().then(function (m) { if (!(m && m.archivo && montajeDirecto(ctrl, m))) abrir(ctrl); });
      return;
    }
    var directa = CAM && !montajeUsado && /[?&]montar=([a-z-]+)/.exec(location.search);   // desde la página de una ocasión: se entra directo al montaje elegido (Xavi, 26/10/2026)
    if (directa) {
      montajeUsado = true;
      var pd = CAMISETAS.filter(function (x) { return x.id === directa[1]; })[0];
      if (pd) { cerrar(); cargarFuentes(); return asistenteMontaje(ctrl, pd); }
    }
    if (TEMAS[claveTema()] && TEMAS[claveTema()].letras) return abrirLetras(ctrl);
    cerrar(); cargarFuentes();
    var tema = TEMAS[claveTema()] || TEMAS.fotos;
    var pleno = tema !== TEMAS.fotos;   // tazas por tema (Xavi, 25/10/2026): primero «Elige tu estilo» a pantalla completa y a 2 columnas
    var v = document.createElement('div'); v.className = 'tzp' + (pleno ? ' tzp--pleno' : ''); v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); v.setAttribute('aria-label', tema.t);
    var c = document.createElement('div'); c.className = 'tzp__c';
    c.innerHTML = '<div class="tzp__cab"><div><p class="tzp__t"></p><p class="tzp__s"></p></div>' +
      '<button type="button" class="tzp__x" aria-label="Cerrar">×</button></div><div class="tzc" data-comp></div>';
    c.querySelector('.tzp__t').textContent = pleno ? 'Elige tu estilo' : tema.t; c.querySelector('.tzp__s').textContent = tema.s;
    var tzc = c.querySelector('[data-comp]');
    tema.ids.forEach(function (id) {
      var p = montaje(id); if (!p) return;
      calidad = 'mini'; var huecos = p.f().elementos.filter(function (e) { return e.hueco; }).length; calidad = 'alta';
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tzc__c'; b.dataset.comp = p.id;
      var im = document.createElement('img'); im.src = urlComp(p.id); im.alt = p.nombre + ' en una ' + PROD + ' personalizada'; im.loading = 'lazy'; im.width = 720; im.height = 480; b.appendChild(im);
      var t = document.createElement('span'); t.className = 'tzc__n'; t.innerHTML = '<b></b><small></small>'; t.firstChild.textContent = p.nombre; t.lastChild.textContent = p.nota; b.appendChild(t);
      b.addEventListener('click', function () {
        if (ctrl.hayDiseño && ctrl.hayDiseño() && !window.confirm('Este diseño sustituye lo que ya has puesto en la ' + PROD + '. ¿Continuar?')) return;
        asistenteMontaje(ctrl, p);   // fotos → textos → taza montada
      });
      tzc.appendChild(b);
    });
    c.querySelector('.tzp__x').addEventListener('click', cerrar);
    v.addEventListener('click', function (ev) { if (ev.target === v) cerrar(); });
    v.appendChild(c); document.body.appendChild(v); abierta = v;
    if (pleno) document.documentElement.classList.add('tz-pleno'); else subirEditor('[data-libre-plantillas]');
    document.addEventListener('keydown', alTeclear);
  }

  /* ---------- FONDO como en las banderas: color, degradado y textura (ventana lateral en PC, hoja desde abajo en móvil) ---------- */
  var COLORES = ['#ffffff', '#f4e4c1', '#fde8ee', '#fbd5e5', '#f7a1bb', '#e8344f', '#b3121f', '#7f1d2b', '#ff7a1a', '#ffd166', '#fcdb04', '#a3e635',
    '#1f8a4c', '#14532d', '#aac6ee', '#4f87d9', '#1f5fa8', '#1b2e5c', '#7a5cc0', '#2f2b4a', '#17171a', '#8f8a80', '#d9d9de', '#b08d57'];
  var estadoFondo = { c: ['#ffffff', '#ffffff'], t: 'v', tx: '', f: 1, e: 0.5 }, fondosAbierto = null;
  function cerrarFondos() { if (fondosAbierto) { fondosAbierto.remove(); fondosAbierto = null; document.removeEventListener('keydown', teclaFondos); document.removeEventListener('pointerdown', fueraFondos, true); liberarPagina(); } }
  // se cierra al tocar fuera de la ventana (la taza, la barra de abajo…); el botón «Fondo» lo reabre él mismo
  function fueraFondos(ev) {
    if (!fondosAbierto || fondosAbierto.contains(ev.target)) return;
    if (ev.target.closest && ev.target.closest('[data-libre-fondo-menu], [data-libre-fondos-abrir]')) return;
    cerrarFondos();
  }
  function teclaFondos(ev) { if (ev.key === 'Escape') cerrarFondos(); }
  function cssDeg(g) {
    var l = g.c.join(',');
    return g.t === 'r' ? 'radial-gradient(ellipse at 50% 30%,' + l + ')' : 'linear-gradient(' + (g.t === 'd' ? '115deg' : 'to bottom') + ',' + l + ')';
  }
  function abrirFondos(ctrl) {
    cerrarFondos(); cerrar(); cargarFuentes();
    var FL = window.FondosLienzo || { degradados: [], texturas: [] };
    var d = document.createElement('div'); d.className = 'tzf'; d.setAttribute('role', 'dialog'); d.setAttribute('aria-label', 'Fondo de la taza');
    d.innerHTML = '<div class="tzf__cab"><div><p class="tzf__t">Fondo</p><p class="tzf__s">Tu foto, un color, un degradado o una textura.</p></div>' +
      '<button type="button" class="tzp__x" aria-label="Cerrar">×</button></div><div class="tzf__cuerpo">' +
      '<button type="button" class="tzf__subir" data-subir><span aria-hidden="true">🖼️</span><span><b>Subir una foto de fondo</b><small>Tu foto cubre toda la taza</small></span></button>' +
      '<button type="button" class="tzf__dado" data-dado><span aria-hidden="true">🎲</span> Sorpresa: probar un fondo</button>' +
      '<p class="tzf__o">o elige un fondo:</p>' +
      '<p class="tzf__h">Con dibujos</p><div class="tzf__bibt" data-bibt></div><div class="tzf__bib" data-bib></div>' +
      '<p class="tzf__h">Colores</p><div class="tzf__col" data-col></div>' +
      '<label class="tzf__otro">Otro color <input type="color" value="#f4e4c1" data-otro></label>' +
      '<p class="tzf__h">Degradados</p><div class="tzf__deg" data-deg></div>' +
      '<p class="tzf__h">Texturas</p><div class="tzf__tex" data-tex></div>' +
      '<label class="tzf__fuerza">Tamaño del dibujo <input type="range" min="0.25" max="1.2" step="0.05" value="0.5" data-tam></label>' +
      '<label class="tzf__fuerza">Intensidad <input type="range" min="0.3" max="1.8" step="0.1" value="1" data-fuerza></label>' +
      '<div class="tzf__acc"><button type="button" class="tzp__chip" data-quitar>Quitar el fondo</button></div></div>';
    var col = d.querySelector('[data-col]'), deg = d.querySelector('[data-deg]'), tex = d.querySelector('[data-tex]');
    var temporizador = null;
    function aplicar() { clearTimeout(temporizador); temporizador = setTimeout(function () { ctrl.fondoSpec({ c: estadoFondo.c.slice(), t: estadoFondo.t, tx: estadoFondo.tx, f: estadoFondo.f, e: estadoFondo.e }); }, 120); }
    function marcar() {
      d.querySelectorAll('[data-hex]').forEach(function (b) { b.classList.toggle('is-on', estadoFondo.c[0] === estadoFondo.c[1] && b.dataset.hex === estadoFondo.c[0]); });
      d.querySelectorAll('[data-g]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.g === estadoFondo.c.join('|') + estadoFondo.t); });
      d.querySelectorAll('[data-tx]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.tx === estadoFondo.tx); });
    }
    COLORES.forEach(function (h) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tzf__sw'; b.style.background = h; b.dataset.hex = h; b.title = h; b.setAttribute('aria-label', 'Color ' + h);
      b.addEventListener('click', function () { estadoFondo.c = [h, h]; estadoFondo.t = 'v'; marcar(); aplicar(); });
      col.appendChild(b);
    });
    d.querySelector('[data-dado]').addEventListener('click', function () {
      var g = FL.degradados[Math.floor(Math.random() * FL.degradados.length)]; if (!g) return;
      estadoFondo.c = g.c.slice(); estadoFondo.t = g.t;
      var tx = FL.texturas.length && Math.random() < 0.5 ? FL.texturas[Math.floor(Math.random() * FL.texturas.length)][0] : '';
      estadoFondo.tx = tx; marcar(); aplicar();
    });
    d.querySelector('[data-otro]').addEventListener('input', function (ev) { var h = ev.target.value; estadoFondo.c = [h, h]; estadoFondo.t = 'v'; marcar(); aplicar(); });
    FL.degradados.forEach(function (g) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tzf__sw tzf__sw--g'; b.style.background = cssDeg(g); b.dataset.g = g.c.join('|') + g.t; b.setAttribute('aria-label', 'Degradado');
      b.addEventListener('click', function () { estadoFondo.c = g.c.slice(); estadoFondo.t = g.t; marcar(); aplicar(); });
      deg.appendChild(b);
    });
    var BUENAS = ['puntos', 'rayas', 'rombos', 'olas', 'hexagonos', 'estrellas', 'zigzag', 'chevron', 'cuadros', 'tablero', 'burbujas', 'hojas', 'trama', 'rayos', 'camuflaje', 'nieve'];
    [['', 'Sin textura']].concat(BUENAS.map(function (k) { return FL.texturas.filter(function (t) { return t[0] === k; })[0]; }).filter(Boolean)).forEach(function (t) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tzp__chip'; b.textContent = t[1]; b.dataset.tx = t[0];
      b.addEventListener('click', function () { estadoFondo.tx = t[0]; marcar(); aplicar(); });
      tex.appendChild(b);
    });
    /* fondos dibujados de la biblioteca (por temática): todos los fondos, en este botón */
    var bibT = d.querySelector('[data-bibt]'), bibG = d.querySelector('[data-bib]'), fondosBib = [], catFondo = '';
    function pintaFondosBib() {
      bibG.innerHTML = '';
      fondosBib.filter(function (x) { return x.cat === catFondo; }).forEach(function (x) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'tzb__i tzb__i--fondo'; b.title = x.tema || '';
        var im = document.createElement('img'); im.src = BIBLIO + '/t/' + x.id + '.webp'; im.alt = x.tema || ''; im.loading = 'lazy'; b.appendChild(im);
        b.addEventListener('click', function () {
          b.disabled = true;
          fetch(BIBLIO + '/g/' + x.id + '.webp').then(function (r) { return r.blob(); }).then(function (bl) {
            b.disabled = false; ctrl.ponerPieza(new File([bl], 'fondo-' + x.id + '.webp', { type: bl.type || 'image/webp' }), true);
            aviso('Fondo puesto. Pon un dibujo y letras encima.');
          }).catch(function () { b.disabled = false; aviso('No se ha podido cargar. Prueba con otro.'); });
        });
        bibG.appendChild(b);
      });
    }
    cargarBiblio().then(function (items) {
      fondosBib = items.filter(function (x) { return x.tipo === 'fondo'; });
      var cs = []; fondosBib.forEach(function (x) { if (cs.indexOf(x.cat) < 0) cs.push(x.cat); });
      if (!cs.length) { bibT.previousElementSibling.hidden = true; return; }
      catFondo = cs.indexOf(bibCat) >= 0 ? bibCat : cs[0];
      cs.forEach(function (k) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'tzp__chip' + (k === catFondo ? ' is-on' : ''); b.textContent = k;
        b.addEventListener('click', function () { catFondo = k; [].forEach.call(bibT.children, function (x) { x.classList.toggle('is-on', x === b); }); pintaFondosBib(); });
        bibT.appendChild(b);
      });
      pintaFondosBib();
    });
    d.querySelector('[data-tam]').addEventListener('input', function (ev) { estadoFondo.e = parseFloat(ev.target.value) || 0.5; if (estadoFondo.tx) aplicar(); });
    d.querySelector('[data-fuerza]').addEventListener('input', function (ev) { estadoFondo.f = parseFloat(ev.target.value) || 1; if (estadoFondo.tx) aplicar(); });
    d.querySelector('[data-subir]').addEventListener('click', function () { cerrarFondos(); ctrl.añadirFondo(); });
    d.querySelector('[data-quitar]').addEventListener('click', function () { ctrl.sinFondo(); });
    d.querySelector('.tzp__x').addEventListener('click', cerrarFondos);
    marcar(); document.body.appendChild(d); fondosAbierto = d;
    // móvil: la hoja ocupa la parte baja y tapa la barra; el editor sube arriba del todo y la página queda bloqueada mientras está abierta
    bloquearPagina('[data-libre-fondo-menu]');
    document.addEventListener('keydown', teclaFondos);
    setTimeout(function () { if (fondosAbierto === d) document.addEventListener('pointerdown', fueraFondos, true); }, 0);
  }

  /* ---------- DIBUJOS, LETRAS Y FONDOS de la biblioteca (Navidad y Halloween), los que Xavi publica desde el panel ---------- */
  var BIBLIO = 'https://artistas.elcajonfriki.com/biblio', biblioP = null, bibCat = '', bibTipo = 'dibujo';
  function cargarBiblio() {
    if (!biblioP) biblioP = fetch(BIBLIO + '/lista.json').then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (j) { return (j && j.items || []).filter(function (x) { return x && /^[0-9a-f]{12}$/.test(x.id) && x.tipo !== 'marco' && !/^Tarjetas/.test(x.cat || ''); }); }).catch(function () { return []; });   // las categorías «Tarjetas · sector» son de las tarjetas de visita, no de la taza
    return biblioP;
  }
  function abrirBiblio(ctrl) {
    cerrar(); cerrarFondos();
    var v = document.createElement('div'); v.className = 'tzp'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); v.setAttribute('aria-label', 'Imágenes');
    var c = document.createElement('div'); c.className = 'tzp__c';
    c.innerHTML = '<div class="tzp__cab"><div><p class="tzp__t">Imágenes</p><p class="tzp__s">Sube tu foto o toca un dibujo o unas letras. Luego lo mueves, lo giras o le cambias el tamaño.</p></div>' +
      '<button type="button" class="tzp__x" aria-label="Cerrar">×</button></div><div class="tzp__fila"><div class="tzp__f" data-t></div><div class="tzp__f" data-k></div></div><div class="tzb__g" data-g><p class="tzp__s">Cargando…</p></div>';
    var g = c.querySelector('[data-g]'), chT = c.querySelector('[data-t]'), chK = c.querySelector('[data-k]'), items = [];
    function chip(caja, txt, on, fn) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tzp__chip' + (on ? ' is-on' : ''); b.textContent = txt;
      b.addEventListener('click', function () { [].forEach.call(caja.children, function (x) { x.classList.toggle('is-on', x === b); }); fn(); }); caja.appendChild(b);
    }
    function pintar() {
      g.innerHTML = '';
      if (bibTipo === 'composicion') { pintaComposiciones(g, items, bibCat, ctrl); return; }
      var lista = items.filter(function (x) { return x.cat === bibCat && x.tipo === bibTipo; });
      if (!lista.length) { g.innerHTML = '<p class="tzp__s">De momento no hay nada aquí.</p>'; return; }
      lista.forEach(function (x) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'tzb__i tzb__i--' + x.tipo; b.title = x.tema || '';
        var im = document.createElement('img'); im.src = BIBLIO + '/t/' + x.id + '.webp'; im.alt = x.tema || ''; im.loading = 'lazy'; b.appendChild(im);
        b.addEventListener('click', function () {
          b.disabled = true;
          fetch(BIBLIO + '/g/' + x.id + '.webp').then(function (r) { return r.blob(); }).then(function (bl) {
            b.disabled = false; ctrl.ponerPieza(new File([bl], (x.tipo === 'lettering' ? 'letras-' : x.tipo === 'fondo' ? 'fondo-' : 'dibujo-') + x.id + '.webp', { type: bl.type || 'image/webp' }), x.tipo === 'fondo');
            aviso(x.tipo === 'fondo' ? 'Fondo puesto. Pon un dibujo y letras encima.' : 'Puesto. Arrástralo donde quieras.');
          }).catch(function () { b.disabled = false; aviso('No se ha podido cargar. Prueba con otro.'); });
        });
        g.appendChild(b);
      });
    }
    /* «Tu foto» y los dibujos de la biblioteca, juntos en una sola pestaña de Imágenes: «Tu foto» el primero de la fila */
    var bf = document.createElement('button'); bf.type = 'button'; bf.className = 'tzp__chip tzp__chip--foto'; bf.textContent = '📷 Tu foto';
    bf.addEventListener('click', function () { cerrar(); ctrl.añadirImagen(); });
    var filaB = c.querySelector('.tzp__fila'); filaB.insertBefore(bf, filaB.firstChild);
    function chipsTipo() {
      chK.innerHTML = '';
      [['dibujo', 'Dibujos'], ['lettering', 'Letras']].forEach(function (a) {
        if (!items.some(function (x) { return x.cat === bibCat && x.tipo === a[0]; })) return;
        chip(chK, a[1], a[0] === bibTipo, function () { bibTipo = a[0]; pintar(); });
      });
    }
    cargarBiblio().then(function (l) {
      items = l; if (!items.length) { g.innerHTML = '<p class="tzp__s">Aún no hay dibujos publicados.</p>'; return; }
      var cats = []; items.forEach(function (x) { if (cats.indexOf(x.cat) < 0) cats.push(x.cat); });
      if (cats.indexOf(bibCat) < 0) bibCat = cats[0];
      cats.forEach(function (k) { chip(chT, k, k === bibCat, function () { bibCat = k; if (bibTipo !== 'composicion' && !items.some(function (x) { return x.cat === k && x.tipo === bibTipo; })) bibTipo = 'dibujo'; chipsTipo(); pintar(); }); });
      chipsTipo(); pintar();
      if (cats.length > 1) {                                   // temáticas: botón + lista a pantalla completa (como el selector de Apple), con buscador si hay muchas (con 20 temáticas, igual) + lista a pantalla completa (como el selector de Apple), con buscador si hay muchas
        var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'tzb__tem';
        var pon = function () { bt.innerHTML = '<span><i>Temática: </i><b></b></span><span>▾</span>'; bt.querySelector('b').textContent = bibCat; };
        pon();
        bt.addEventListener('click', function () {
          var l = document.createElement('div'); l.className = 'tzb__lista'; l.setAttribute('role', 'dialog');
          l.innerHTML = '<div class="tzb__lista-cab"><b>Temática</b><button type="button" class="tzp__x" aria-label="Cerrar">×</button></div>' + (cats.length > 8 ? '<input type="search" class="tzb__lista-q" placeholder="Buscar…">' : '') + '<div class="tzb__lista-cu"></div>';
          var cu = l.querySelector('.tzb__lista-cu'), filas = [];
          cats.forEach(function (k, i) {
            var f = document.createElement('button'); f.type = 'button'; f.className = 'tzb__lista-f' + (k === bibCat ? ' is-on' : ''); f.innerHTML = '<span></span><span>' + (k === bibCat ? '✓' : '') + '</span>'; f.firstChild.textContent = k;
            f.addEventListener('click', function () { chT.children[i].click(); pon(); l.remove(); }); cu.appendChild(f); filas.push(f);
          });
          var q = l.querySelector('.tzb__lista-q');
          if (q) q.addEventListener('input', function () { var t = q.value.trim().toLowerCase(); filas.forEach(function (f) { f.hidden = !!t && f.firstChild.textContent.toLowerCase().indexOf(t) < 0; }); });
          l.querySelector('.tzp__x').addEventListener('click', function () { l.remove(); });
          document.body.appendChild(l);
        });
        chT.style.display = 'none'; chT.parentNode.insertBefore(bt, chT);
      }
    });
    c.querySelector('.tzp__x').addEventListener('click', cerrar);
    v.addEventListener('click', function (ev) { if (ev.target === v) cerrar(); });
    v.appendChild(c); document.body.appendChild(v); abierta = v; subirEditor('[data-libre-biblio]');
    document.addEventListener('keydown', alTeclear);
  }


  /* ---------- COMPOSICIONES de la taza: dibujo + letras (+ fondo) ya colocados en las dos caras ----------
     Las caras visibles son x 0–8 y x 12–20 (centros CL y CR); el centro es el asa. Cada pieza se encaja en su caja respetando su forma.
     Se montan con piezas al azar de la temática elegida y NO quedan bloqueadas: el cliente las mueve, las gira y les cambia el tamaño. */
  var DISEÑOS = [
    { id: 'igual', nombre: 'Igual por los dos lados', cajas: [['l1', CL, 2.5, 5.6, 2.8], ['d1', CL, 6.1, 5.0, 4.6], ['l1', CR, 2.5, 5.6, 2.8], ['d1', CR, 6.1, 5.0, 4.6]] },
    { id: 'lado', nombre: 'Dibujo a un lado, letras al otro', cajas: [['d1', CL, 4.975, 5.8, 7.2], ['l1', CR, 4.975, 6.0, 3.8]] },
    { id: 'dos', nombre: 'Dos conjuntos distintos', cajas: [['l1', CL, 2.5, 5.6, 2.8], ['d1', CL, 6.1, 5.0, 4.6], ['l2', CR, 2.5, 5.6, 2.8], ['d2', CR, 6.1, 5.0, 4.6]] }
  ];
  var PALETAS = { Navidad: ['#ffffff', '#fff4ef', '#eef7f0', '#fdecec', '#eef4fb'], Halloween: ['#ffffff', '#fff3e3', '#f1eafa', '#eaf3e6', '#fdeedd'] };
  var ultimoComp = {};
  function alAzar(l, evita) { var c = l.filter(function (x) { return x.id !== evita; }); c = c.length ? c : l; return c[Math.floor(Math.random() * c.length)]; }
  function elige(items, cat, diseño, fondoTextura) {
    var d = items.filter(function (x) { return x.cat === cat && x.tipo === 'dibujo'; }), l = items.filter(function (x) { return x.cat === cat && x.tipo === 'lettering'; }), f = items.filter(function (x) { return x.cat === cat && x.tipo === 'fondo'; });
    var r = {}; r.d1 = alAzar(d, ultimoComp.d1); r.l1 = alAzar(l, ultimoComp.l1);
    r.d2 = alAzar(d.filter(function (x) { return x.id !== r.d1.id; }).length ? d.filter(function (x) { return x.id !== r.d1.id; }) : d);
    r.l2 = alAzar(l.filter(function (x) { return x.id !== r.l1.id; }).length ? l.filter(function (x) { return x.id !== r.l1.id; }) : l);
    r.f = fondoTextura && f.length ? alAzar(f, ultimoComp.f) : null;
    r.color = (PALETAS[cat] || PALETAS.Navidad)[Math.floor(Math.random() * (PALETAS[cat] || PALETAS.Navidad).length)];
    ultimoComp = { d1: r.d1.id, l1: r.l1.id, f: r.f && r.f.id };
    return r;
  }
  function encaja(x, cx, cy, bw, bh) { var e = Math.min(bw / x.w, bh / x.h); return { cx: cx, cy: cy, w: x.w * e, h: x.h * e }; }
  var blobs = {};
  function blobDe(id) {
    return blobs[id] || (blobs[id] = fetch(BIBLIO + '/g/' + id + '.webp').then(function (r) { return r.blob(); }).then(function (b) { return URL.createObjectURL(b); }));
  }
  function monta(diseño, p, ctrl) {
    var ids = ['d1', 'd2', 'l1', 'l2'].filter(function (k) { return diseño.cajas.some(function (c) { return c[0] === k; }); });
    var pedir = ids.map(function (k) { return blobDe(p[k].id); }).concat(p.f ? [blobDe(p.f.id)] : []);
    return Promise.all(pedir).then(function (urls) {
      var src = {}; ids.forEach(function (k, i) { src[k] = urls[i]; });
      var els = [];
      if (p.f) { var h = W * p.f.h / p.f.w; els.push(base({ tipo: 'imagen', fondo: true, colorFondo: null, cx: W / 2, cy: H / 2, w: W, h: Math.max(H, h), src: urls[ids.length], _c: p.color })); }
      else els.push(fondo(p.color));
      diseño.cajas.forEach(function (c) {
        var pz = p[c[0]], b = encaja(pz, c[1], c[2], c[3], c[4]);
        els.push(base({ tipo: 'imagen', fondo: false, colorFondo: null, cx: b.cx, cy: b.cy, w: b.w, h: b.h, src: src[c[0]] }));
      });
      ctrl.composicion({ vista: 'panoramica', elementos: els });
    });
  }
  /* Pestaña «Con dibujos» de Plantillas: elegir temática (lista a pantalla completa si hay varias) y los diseños montados con dibujos y letras */
  function pintaConDibujos(gd, ctrl, temas) {
    gd.innerHTML = '<p class="tzp__s">Cargando…</p>';
    cargarBiblio().then(function (items) {
      gd.innerHTML = '';
      var cats = []; items.forEach(function (x) { if (cats.indexOf(x.cat) < 0) cats.push(x.cat); });
      if (!cats.length) { gd.innerHTML = '<p class="tzp__s">Aún no hay dibujos publicados.</p>'; return; }
      if (cats.indexOf(bibCat) < 0) bibCat = cats[0];
      var zona = document.createElement('div'); zona.className = 'tzb__g';
      function pinta() { zona.innerHTML = ''; pintaComposiciones(zona, items, bibCat, ctrl); }
      if (cats.length > 1) {
        var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'tzb__tem';
        var pon = function () { bt.innerHTML = '<span><i>Temática: </i><b></b></span><span>▾</span>'; bt.querySelector('b').textContent = bibCat; };
        pon();
        bt.addEventListener('click', function () {
          var l = document.createElement('div'); l.className = 'tzb__lista'; l.setAttribute('role', 'dialog');
          l.innerHTML = '<div class="tzb__lista-cab"><b>Temática</b><button type="button" class="tzp__x" aria-label="Cerrar">×</button></div>' + (cats.length > 8 ? '<input type="search" class="tzb__lista-q" placeholder="Buscar…">' : '') + '<div class="tzb__lista-cu"></div>';
          var cu = l.querySelector('.tzb__lista-cu'), filas = [];
          cats.forEach(function (k) {
            var f = document.createElement('button'); f.type = 'button'; f.className = 'tzb__lista-f' + (k === bibCat ? ' is-on' : ''); f.innerHTML = '<span></span><span>' + (k === bibCat ? '✓' : '') + '</span>'; f.firstChild.textContent = k;
            f.addEventListener('click', function () { bibCat = k; pon(); pinta(); l.remove(); }); cu.appendChild(f); filas.push(f);
          });
          var q = l.querySelector('.tzb__lista-q');
          if (q) q.addEventListener('input', function () { var t = q.value.trim().toLowerCase(); filas.forEach(function (f) { f.hidden = !!t && f.firstChild.textContent.toLowerCase().indexOf(t) < 0; }); });
          l.querySelector('.tzp__x').addEventListener('click', function () { l.remove(); });
          document.body.appendChild(l);
        });
        temas.appendChild(bt);
      }
      gd.appendChild(zona); pinta();
    });
  }

  function pintaComposiciones(g, items, cat, ctrl) {
    var tiene = function (t) { return items.some(function (x) { return x.cat === cat && x.tipo === t; }); };
    g.innerHTML = '';
    var cab = document.createElement('p'); cab.className = 'tzp__s tzb__comp-nota'; cab.textContent = 'Elige cómo colocar un dibujo y unas letras de esta temática. Se montan al azar: vuelve a tocar para ver otra combinación.'; g.appendChild(cab);
    function tarjeta(titulo, sub, cajas, accion) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'tzb__c';
      var v = document.createElement('span'); v.className = 'tzb__cv';
      cajas.forEach(function (c) { var n = document.createElement('i'); n.className = 'tzb__cb tzb__cb--' + c[0].charAt(0); n.style.left = ((c[1] - c[3] / 2) / W * 100) + '%'; n.style.top = ((c[2] - c[4] / 2) / H * 100) + '%'; n.style.width = (c[3] / W * 100) + '%'; n.style.height = (c[4] / H * 100) + '%'; n.textContent = c[0].charAt(0) === 'd' ? '🖼' : 'Aa'; v.appendChild(n); });
      var asa = document.createElement('u'); asa.className = 'tzb__asa'; v.appendChild(asa);
      b.appendChild(v); var t = document.createElement('span'); t.className = 'tzb__ct'; t.innerHTML = '<b></b><small></small>'; t.firstChild.textContent = titulo; t.lastChild.textContent = sub; b.appendChild(t);
      b.addEventListener('click', function () { b.disabled = true; accion().then(function () { b.disabled = false; aviso('Listo. Toca una pieza para moverla. Toca otra vez el diseño para otra combinación.'); }).catch(function () { b.disabled = false; aviso('No se ha podido cargar. Prueba otra vez.'); }); });
      g.appendChild(b);
    }
    if (!(tiene('dibujo') && tiene('lettering'))) { g.appendChild(document.createElement('p')).textContent = 'Hacen falta dibujos y letras de esta temática.'; return; }
    DISEÑOS.forEach(function (d) { tarjeta(d.nombre, 'Fondo liso de color', d.cajas, function () { return monta(d, elige(items, cat, d, false), ctrl); }); });
    DISEÑOS.forEach(function (d) { if (tiene('fondo')) tarjeta(d.nombre, 'Con fondo de textura', d.cajas, function () { return monta(d, elige(items, cat, d, true), ctrl); }); });
    tarjeta('🎲 Sorpresa', 'Todo al azar', DISEÑOS[0].cajas, function () { var d = DISEÑOS[Math.floor(Math.random() * DISEÑOS.length)]; return monta(d, elige(items, cat, d, tiene('fondo') && Math.random() < 0.5), ctrl); });
  }

  /* 🎲 Sorpresa (barra de arriba en móvil): la primera vez pregunta la temática (o «Cualquiera»); después repite con esa */
  var sorpresaTema; /* undefined = aún sin preguntar; '' = cualquiera */
  function preguntaTema(cats) {
    return new Promise(function (ok) {
      var l = document.createElement('div'); l.className = 'tzb__lista'; l.setAttribute('role', 'dialog');
      l.innerHTML = '<div class="tzb__lista-cab"><b>¿De qué temática?</b><button type="button" class="tzp__x" aria-label="Cerrar">×</button></div>' + (cats.length > 8 ? '<input type="search" class="tzb__lista-q" placeholder="Buscar…">' : '') + '<div class="tzb__lista-cu"></div>';
      var cu = l.querySelector('.tzb__lista-cu'), filas = [];
      function fila(txt, val, fijo) {
        var f = document.createElement('button'); f.type = 'button'; f.className = 'tzb__lista-f'; f.innerHTML = '<span></span><span></span>'; f.firstChild.textContent = txt;
        f.addEventListener('click', function () { l.remove(); ok(val); }); cu.appendChild(f); if (!fijo) filas.push(f);
      }
      fila('🎲 Cualquiera', '', true);
      cats.forEach(function (k) { fila(k, k); });
      var q = l.querySelector('.tzb__lista-q');
      if (q) q.addEventListener('input', function () { var t = q.value.trim().toLowerCase(); filas.forEach(function (f) { f.hidden = !!t && f.firstChild.textContent.toLowerCase().indexOf(t) < 0; }); });
      l.querySelector('.tzp__x').addEventListener('click', function () { l.remove(); ok(null); });
      document.body.appendChild(l);
    });
  }
  function sorpresa(ctrl) {
    return cargarBiblio().then(function (items) {
      var cats = []; items.forEach(function (x) { if (cats.indexOf(x.cat) < 0) cats.push(x.cat); });
      cats = cats.filter(function (c) { return items.some(function (x) { return x.cat === c && x.tipo === 'dibujo'; }) && items.some(function (x) { return x.cat === c && x.tipo === 'lettering'; }); });
      if (!cats.length) { aviso('Aún no hay dibujos y letras para la sorpresa.'); return; }
      var antes = sorpresaTema === undefined && cats.length > 1 ? preguntaTema(cats) : Promise.resolve(sorpresaTema === undefined ? '' : sorpresaTema);
      return antes.then(function (t) {
        if (t === null) return;   /* cerró la pregunta: no hace nada y volverá a preguntar */
        sorpresaTema = t;
        var cat = t && cats.indexOf(t) >= 0 ? t : cats[Math.floor(Math.random() * cats.length)], d = DISEÑOS[Math.floor(Math.random() * DISEÑOS.length)];
        var conFondo = items.some(function (x) { return x.cat === cat && x.tipo === 'fondo'; }) && Math.random() < .5;
        return monta(d, elige(items, cat, d, conFondo), ctrl).then(function () { aviso('Sorpresa de ' + cat + '. Toca otra vez 🎲 para otra.'); });
      });
    }).catch(function () { aviso('No se ha podido cargar. Prueba otra vez.'); });
  }

  /* Texto en móvil (Xavi, 25/10/2026): «Listo» ocupa el sitio de «Insertar» (hacen lo mismo) y se quita la fila de «Listo» de arriba, que gastaba alto */
  var intentosListo = 0, esperaListo = setInterval(function () {
    var b = document.querySelector('.rop-libre-wrap--fondos-ventana .edl__opc__b--insertar'); intentosListo++;
    if (b) { clearInterval(esperaListo); b.textContent = '✓ Listo'; } else if (intentosListo > 40) clearInterval(esperaListo);
  }, 500);
  /* Tazas con plantilla en móvil (Xavi, 25/10/2026): «una vez elegida la plantilla es lo que vale». Se quitan el Sorpresa global y las pestañas de añadir;
     abajo quedan Estilo y Fondo; lo demás (añadir texto o imagen, ver, capas, guardar, zoom) va en «⋯ Más». */
  if (window.IMP_TAZA_TEMA && TEMAS[window.IMP_TAZA_TEMA] && window.IMP_TAZA_TEMA !== 'fotos') {
    document.documentElement.classList.add('tz-tema');
    var intentosMas = 0, esperaMas = setInterval(function () {
      var cab = document.querySelector('.rop-libre-cab'), x = cab && cab.querySelector('.rop-libre-cab__x'); intentosMas++;
      if (!x || !document.querySelector('.rop-libre-rail__b[data-libre-plantillas]')) { if (intentosMas > 40) clearInterval(esperaMas); return; }
      clearInterval(esperaMas);
      var tabP = document.querySelector('.rop-libre-rail__b[data-libre-plantillas]');
      var sp = tabP.querySelectorAll('span'); if (sp.length) sp[sp.length - 1].textContent = 'Estilo'; else tabP.textContent = 'Estilo';
      var mas = document.createElement('button'); mas.type = 'button'; mas.className = 'tzm__b'; mas.textContent = '⋯ Más'; mas.setAttribute('aria-haspopup', 'true'); mas.setAttribute('aria-expanded', 'false');
      var pop = document.createElement('div'); pop.className = 'tzm__p'; pop.hidden = true;
      [['Añadir un texto', '[data-libre-texto]'], ['Añadir una imagen o dibujo', '[data-libre-biblio]'], ['Ver cómo queda', '.rop-libre-top__b[data-libre-ver]'], ['Capas', '[data-libre-capas]'],
       ['Guardar el diseño', '.rop-gc__b[data-gc="guardar"]'], ['Mis diseños guardados', '.rop-gc__b[data-gc="cargar"]'], ['Acercar', '.edl__zoom__b:nth-of-type(1)'], ['Alejar', '.edl__zoom__b:nth-of-type(2)']].forEach(function (a) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'tzm__i'; b.textContent = a[0];
        b.addEventListener('click', function () { pop.hidden = true; mas.setAttribute('aria-expanded', 'false'); var t = document.querySelector(a[1]); if (t) t.click(); });
        pop.appendChild(b);
      });
      mas.addEventListener('click', function (ev) { ev.stopPropagation(); pop.hidden = !pop.hidden; mas.setAttribute('aria-expanded', String(!pop.hidden)); });
      document.addEventListener('click', function () { pop.hidden = true; mas.setAttribute('aria-expanded', 'false'); });
      cab.insertBefore(mas, x); cab.appendChild(pop);
    }, 500);
  }
  /* Página propia del montaje (Xavi, 26/10/2026: primero la ocasión, luego los montajes, y al final los productos): hace el montaje y va a «Tu montaje» */
  function hacerMontaje(id, volver, destino) {
    var pd = CAMISETAS.filter(function (x) { return x.id === id; })[0];
    if (!pd) { location.href = volver; return false; }
    cargarFuentes(); asistenteMontaje(null, pd, { volver: volver, destino: destino }); return true;
  }
  window.TazaPlantillas = { hacerMontaje: hacerMontaje, sorpresa: sorpresa, abrir: abrir, abrirFondos: abrirFondos, abrirBiblio: abrirBiblio, lista: PLANTILLAS, cerrar: cerrar };
})();
